import React, { useMemo, useState } from "react";
import "./ManualeQrMenu.css";
import logo from "./logo-quadrato.png";
const sezioniManuale = [
  {
    id: "introduzione",
    titolo: "Introduzione",
    icona: "📖",
    voci: [
      { id: "benvenuto", titolo: "Benvenuto in QrMenu" },
      { id: "come-funziona", titolo: "Come funziona QrMenu" },
    ],
  },
  {
    id: "gestore",
    titolo: "Gestore",
    icona: "👤",
    voci: [
      { id: "dashboard", titolo: "Dashboard Gestore" },
      { id: "menu", titolo: "Gestione Menu" },
{ id: "menu-categorie", titolo: "↳ Categorie" },
{ id: "menu-aggiungi", titolo: "↳ Aggiungere un piatto" },
{ id: "menu-modifica", titolo: "↳ Modificare un piatto" },
{ id: "menu-ordinamento", titolo: "↳ Ordinare i piatti" },
{ id: "menu-visibilita", titolo: "↳ Visibilità piatti" },
{ id: "menu-promozioni", titolo: "↳ Promozioni" },
{ id: "menu-foto", titolo: "↳ Foto e immagini AI" },
{ id: "menu-traduzioni", titolo: "↳ Traduzioni AI" },
{ id: "menu-suggerimenti", titolo: "↳ Suggerimenti AI" },
            { id: "ordini", titolo: "Ordini" },
      { id: "ordini-panoramica", titolo: "↳ Panoramica ordini" },
      { id: "ordini-filtri", titolo: "↳ Filtrare gli ordini" },
      { id: "ordini-stati", titolo: "↳ Stati degli ordini" },
      { id: "ordini-modifica", titolo: "↳ Modificare un ordine" },
      { id: "ordini-elimina", titolo: "↳ Eliminare un ordine" },
            { id: "cassa", titolo: "Cassa" },
      { id: "cassa-panoramica", titolo: "↳ Panoramica cassa" },
      { id: "cassa-filtri", titolo: "↳ Filtrare i tavoli" },
      { id: "cassa-pagamento", titolo: "↳ Segnare come pagato" },
      { id: "cassa-coperti", titolo: "↳ Gestione coperti" },
      { id: "cassa-pagati", titolo: "↳ Tavoli pagati" },
      { id: "cassa-chiusura", titolo: "↳ Chiudere la cassa" },
      { id: "asporto", titolo: "Gestione Asporto" },
{ id: "asporto-qr", titolo: "↳ QR Asporto" },
{ id: "asporto-reset", titolo: "↳ Reset numero asporto" },
{ id: "asporto-slot", titolo: "↳ Slot Asporto" },
      { id: "camerieri", titolo: "Gestione Camerieri" },
{ id: "camerieri-installazione", titolo: "↳ Installare App Cameriere" },
{ id: "camerieri-aggiungi", titolo: "↳ Aggiungere un cameriere" },
{ id: "camerieri-accesso", titolo: "↳ QR personale cameriere" },
{ id: "camerieri-notifiche", titolo: "↳ Categorie di notifica" },
{ id: "camerieri-standby", titolo: "↳ Standby cameriere" },
{ id: "camerieri-elimina", titolo: "↳ Eliminare un cameriere" },
 { id: "assistente-ai", titolo: "Assistente AI" },
{ id: "assistente-ai-simulazione", titolo: "↳ Simula esperienza cliente" },
{ id: "assistente-ai-upselling", titolo: "↳ Simulazione Upselling" },
{ id: "assistente-ai-regole", titolo: "↳ Regole AI" },
{ id: "assistente-ai-strategia", titolo: "↳ Strategia AI" },
{ id: "assistente-ai-prioritari", titolo: "↳ Piatti prioritari" },
{ id: "assistente-ai-suggerimenti", titolo: "↳ Regole suggerimenti" },
{ id: "assistente-ai-sala", titolo: "↳ AI Sala" },
{ id: "sala", titolo: "Sala in tempo reale" },
{ id: "sala-stati", titolo: "↳ Stati dei tavoli" },
{ id: "sala-occupato", titolo: "↳ Gestire un tavolo occupato" },
{ id: "sala-nuovo-ordine", titolo: "↳ Inserire un nuovo ordine" },
{ id: "sala-concludi", titolo: "↳ Concludere esperienza e incasso" },
{ id: "sala-alert", titolo: "↳ Alert Supervisore Sala" },
{ id: "promozioni", titolo: "Promozioni" },
{ id: "promozioni-popup", titolo: "↳ Promozioni Popup" },

      { id: "chiamate", titolo: "Chiamate di servizio" },
      { id: "report", titolo: "Analisi performance" },
    ],
  },
{
  id: "cameriere",
  titolo: "App Cameriere",
  icona: "🛎️",
  voci: [
    { id: "cameriere-introduzione", titolo: "Panoramica" },
    { id: "cameriere-installazione", titolo: "Installazione" },
    { id: "cameriere-utilizzo", titolo: "Utilizzo" },
    { id: "cameriere-notifiche", titolo: "Notifiche" },
    { id: "cameriere-standby", titolo: "Standby" },
  ],
},
  {
    id: "cucina",
    titolo: "App Cucina",
    icona: "👨‍🍳",
    voci: [
      { id: "cucina-introduzione", titolo: "Panoramica" },
      { id: "cucina-installazione", titolo: "Installazione" },
      { id: "cucina-ordini", titolo: "Gestione ordini" },
      { id: "cucina-stampa", titolo: "Stampa ordini" },
    ],
  },
  {
    id: "qrprint",
    titolo: "QrPrint",
    icona: "🖨️",
    voci: [
      { id: "qrprint-introduzione", titolo: "Cos'è QrPrint" },
      { id: "qrprint-installazione", titolo: "Installazione" },
      { id: "qrprint-configurazione", titolo: "Configurazione" },
      { id: "qrprint-stampante", titolo: "Collegamento stampante" },
      { id: "qrprint-automatica", titolo: "Stampa automatica" },
      { id: "qrprint-problemi", titolo: "Problemi comuni" },
    ],
  },
  {
    id: "assistenza",
    titolo: "Assistenza",
    icona: "💬",
    voci: [
      { id: "faq", titolo: "Domande frequenti" },
      { id: "problemi", titolo: "Risoluzione problemi" },
    ],
  },
];

const contenuti = {
  benvenuto: {
    categoria: "INTRODUZIONE",
    titolo: "Benvenuto in QrMenu",
    descrizione:
      "La guida operativa per utilizzare tutte le principali funzioni di QrMenu.",
    tipo: "benvenuto",
  },

  "come-funziona": {
    categoria: "INTRODUZIONE",
    titolo: "Come funziona QrMenu",
    descrizione:
      "Scopri come cliente, sala, cucina e gestore comunicano attraverso un unico sistema.",
  },

  dashboard: {
    categoria: "GESTORE",
    titolo: "Dashboard Gestore",
    descrizione:
      "Il centro di controllo del tuo locale. Da qui puoi accedere alle principali funzioni di QrMenu.",
    tipo: "dashboard",
  },

  menu: {
    categoria: "GESTORE",
    titolo: "Gestione Menu",
    descrizione:
      "Crea, modifica e organizza il menu digitale del tuo locale.",
  },

  "menu-categorie": {
    categoria: "GESTIONE MENU",
    titolo: "Categorie",
    descrizione: "Crea e organizza le categorie utilizzate nel menu.",
  },

  "menu-aggiungi": {
    categoria: "GESTIONE MENU",
    titolo: "Aggiungere un piatto",
    descrizione:
      "Inserisci un nuovo piatto con prezzo, categoria, descrizione, ingredienti, allergeni e immagine.",
  },

  "menu-modifica": {
    categoria: "GESTIONE MENU",
    titolo: "Modificare un piatto",
    descrizione: "Aggiorna le informazioni di un piatto già presente nel menu.",
  },

  "menu-ordinamento": {
    categoria: "GESTIONE MENU",
    titolo: "Ordinare i piatti",
    descrizione: "Modifica l'ordine con cui i piatti vengono mostrati nel menu.",
  },

  "menu-visibilita": {
    categoria: "GESTIONE MENU",
    titolo: "Visibilità piatti",
    descrizione: "Mostra o nascondi temporaneamente un piatto dal menu del cliente.",
  },

  "menu-promozioni": {
    categoria: "GESTIONE MENU",
    titolo: "Promozioni",
    descrizione: "Gestisci le funzioni promozionali associate ai singoli piatti.",
  },

  "menu-foto": {
    categoria: "GESTIONE MENU",
    titolo: "Foto e immagini AI",
    descrizione:
      "Carica una fotografia oppure utilizza l'Intelligenza Artificiale per generare l'immagine di un piatto.",
  },

  "menu-traduzioni": {
    categoria: "GESTIONE MENU",
    titolo: "Traduzioni AI",
    descrizione:
      "Traduci con l'Intelligenza Artificiale piatti, categorie e testi dell'interfaccia.",
  },

  "menu-suggerimenti": {
    categoria: "GESTIONE MENU",
    titolo: "Suggerimenti AI",
    descrizione: "Gestisci i suggerimenti intelligenti mostrati all'interno del menu.",
  },

   ordini: {
    categoria: "GESTORE",
    titolo: "Ordini",
    descrizione:
      "Consulta, filtra e gestisci gli ordini ricevuti dal tuo locale.",
  },

  "ordini-panoramica": {
    categoria: "ORDINI",
    titolo: "Panoramica ordini",
    descrizione:
      "Consulta gli ordini ricevuti in sala e da asporto e controllane rapidamente lo stato.",
  },

  "ordini-filtri": {
    categoria: "ORDINI",
    titolo: "Filtrare gli ordini",
    descrizione:
      "Utilizza i filtri per trovare rapidamente gli ordini che vuoi consultare.",
  },

  "ordini-stati": {
    categoria: "ORDINI",
    titolo: "Stati degli ordini",
    descrizione:
      "Consulta gli ordini in base allo stato raggiunto durante il servizio.",
  },

  "ordini-modifica": {
    categoria: "ORDINI",
    titolo: "Modificare un ordine",
    descrizione:
      "Modifica un ordine esistente, aggiungi altri piatti oppure inserisci una nota.",
  },

  "ordini-elimina": {
    categoria: "ORDINI",
    titolo: "Eliminare un ordine",
    descrizione:
      "Rimuovi un ordine quando è necessario eliminarlo dalla gestione ordini.",
  },

  cassa: {
    categoria: "GESTORE",
    titolo: "Cassa",
    descrizione:
      "Gestisci i tavoli attivi, registra i pagamenti e consulta i tavoli già pagati.",
  },

  "cassa-panoramica": {
    categoria: "CASSA",
    titolo: "Panoramica cassa",
    descrizione:
      "Consulta i tavoli attivi e le informazioni principali relative agli ordini da incassare.",
  },

  "cassa-filtri": {
    categoria: "CASSA",
    titolo: "Filtrare i tavoli",
    descrizione:
      "Utilizza i filtri temporali per trovare rapidamente i tavoli e gli ordini che vuoi consultare.",
  },

  "cassa-pagamento": {
    categoria: "CASSA",
    titolo: "Segnare come pagato",
    descrizione:
      "Registra il pagamento di un tavolo o di un ordine da asporto.",
  },

  "cassa-coperti": {
    categoria: "CASSA",
    titolo: "Gestione coperti",
    descrizione:
      "Imposta il numero dei coperti prima di confermare il pagamento del tavolo.",
  },

  "cassa-pagati": {
    categoria: "CASSA",
    titolo: "Tavoli pagati",
    descrizione:
      "Consulta i tavoli e gli ordini già registrati come pagati.",
  },

  "cassa-chiusura": {
    categoria: "CASSA",
    titolo: "Chiudere la cassa",
    descrizione:
      "Utilizza il comando Chiudi cassa per completare le operazioni di chiusura.",
  },

 asporto: {
  categoria: "GESTORE",
  titolo: "Gestione Asporto",
  descrizione:
    "Configura le funzioni dedicate agli ordini da asporto.",
},

"asporto-qr": {
  categoria: "GESTIONE ASPORTO",
  titolo: "QR Asporto",
  descrizione:
    "Visualizza, copia o stampa il QR Code utilizzato dai clienti per accedere al menu da asporto.",
},

"asporto-reset": {
  categoria: "GESTIONE ASPORTO",
  titolo: "Reset numero asporto",
  descrizione:
    "Azzera il contatore progressivo degli ordini da asporto.",
},

"asporto-slot": {
  categoria: "GESTIONE ASPORTO",
  titolo: "Slot Asporto",
  descrizione:
    "Configura gli orari disponibili e la capacità degli slot dedicati agli ordini da asporto.",
},

camerieri: {
  categoria: "GESTORE",
  titolo: "Gestione Camerieri",
  descrizione:
    "Crea i camerieri, configura gli accessi e gestisci le notifiche dedicate al personale di sala.",
},

"camerieri-installazione": {
  categoria: "GESTIONE CAMERIERI",
  titolo: "Installare App Cameriere",
  descrizione:
    "Installa l'App Cameriere sul dispositivo utilizzato dal personale di sala.",
},

"camerieri-aggiungi": {
  categoria: "GESTIONE CAMERIERI",
  titolo: "Aggiungere un cameriere",
  descrizione:
    "Crea un nuovo profilo cameriere da utilizzare durante il servizio.",
},

"camerieri-accesso": {
  categoria: "GESTIONE CAMERIERI",
  titolo: "QR personale cameriere",
  descrizione:
    "Utilizza il QR Code personale per accedere all'App Cameriere con il profilo corretto.",
},

"camerieri-notifiche": {
  categoria: "GESTIONE CAMERIERI",
  titolo: "Categorie di notifica",
  descrizione:
    "Scegli per quali categorie del menu il cameriere deve ricevere notifiche.",
},

"camerieri-standby": {
  categoria: "GESTIONE CAMERIERI",
  titolo: "Standby cameriere",
  descrizione:
    "Gestisci lo stato operativo del cameriere durante il servizio.",
},

"camerieri-elimina": {
  categoria: "GESTIONE CAMERIERI",
  titolo: "Eliminare un cameriere",
  descrizione:
    "Rimuovi un profilo cameriere quando non deve più essere utilizzato.",
},

 "assistente-ai": {
  categoria: "INTELLIGENZA ARTIFICIALE",
  titolo: "Assistente AI",
  descrizione:
    "Configura la strategia dell'Intelligenza Artificiale e verifica come verrà utilizzata nell'esperienza del cliente.",
},

"assistente-ai-simulazione": {
  categoria: "ASSISTENTE AI",
  titolo: "Simula esperienza cliente",
  descrizione:
    "Simula il comportamento di un cliente e verifica i consigli generati dall'Intelligenza Artificiale.",
},

"assistente-ai-upselling": {
  categoria: "ASSISTENTE AI",
  titolo: "Simulazione Upselling",
  descrizione:
    "Seleziona un piatto e verifica quali proposte di upselling vengono generate dall'Intelligenza Artificiale.",
},

"assistente-ai-regole": {
  categoria: "ASSISTENTE AI",
  titolo: "Regole AI",
  descrizione:
    "Configura le regole utilizzate dall'Assistente AI per guidare i suggerimenti mostrati ai clienti.",
},

"assistente-ai-strategia": {
  categoria: "ASSISTENTE AI",
  titolo: "Strategia AI",
  descrizione:
    "Imposta obiettivo, intensità e tono utilizzati dall'Assistente AI.",
},

"assistente-ai-prioritari": {
  categoria: "ASSISTENTE AI",
  titolo: "Piatti prioritari",
  descrizione:
    "Seleziona i piatti che l'Assistente AI deve privilegiare nelle proprie strategie.",
},

"assistente-ai-suggerimenti": {
  categoria: "ASSISTENTE AI",
  titolo: "Regole suggerimenti",
  descrizione:
    "Definisci quali categorie suggerire in base alla categoria scelta dal cliente.",
},

"assistente-ai-sala": {
  categoria: "ASSISTENTE AI",
  titolo: "AI Sala",
  descrizione:
    "Configura gli avvisi intelligenti utilizzati dal Supervisore Sala.",
},

sala: {
  categoria: "GESTORE",
  titolo: "Sala in tempo reale",
  descrizione:
    "Controlla lo stato dei tavoli, gestisci gli ordini e intervieni rapidamente durante il servizio.",
},

"sala-stati": {
  categoria: "SALA IN TEMPO REALE",
  titolo: "Stati dei tavoli",
  descrizione:
    "Consulta la griglia della sala e riconosci rapidamente lo stato dei tavoli.",
},

"sala-occupato": {
  categoria: "SALA IN TEMPO REALE",
  titolo: "Gestire un tavolo occupato",
  descrizione:
    "Apri un tavolo attivo per controllare gli ordini e le informazioni relative all'esperienza.",
},

"sala-nuovo-ordine": {
  categoria: "SALA IN TEMPO REALE",
  titolo: "Inserire un nuovo ordine",
  descrizione:
    "Inserisci manualmente un nuovo ordine direttamente dalla Sala in tempo reale.",
},

"sala-concludi": {
  categoria: "SALA IN TEMPO REALE",
  titolo: "Concludere esperienza e incasso",
  descrizione:
    "Concludi l'esperienza del tavolo e accedi alla gestione dell'incasso.",
},

"sala-alert": {
  categoria: "SALA IN TEMPO REALE",
  titolo: "Alert Supervisore Sala",
  descrizione:
    "Utilizza gli alert dell'AI Sala per individuare situazioni che richiedono attenzione.",
},

promozioni: {
  categoria: "GESTORE",
  titolo: "Promozioni",
  descrizione:
    "Crea e gestisci le promozioni mostrate ai clienti all'interno del menu.",
},

"promozioni-popup": {
  categoria: "PROMOZIONI",
  titolo: "Promozioni Popup",
  descrizione:
    "Crea e gestisci i popup promozionali mostrati ai clienti durante la consultazione del menu.",
},

  chiamate: {
    categoria: "GESTORE",
    titolo: "Chiamate di servizio",
    descrizione:
      "Visualizza e gestisci le richieste inviate dai clienti.",
  },

  report: {
  categoria: "GESTORE",
  titolo: "Analisi performance",
  descrizione:
    "Consulta i principali KPI del locale, analizza vendite e tempi operativi ed esporta i dati.",
},

"cameriere-introduzione": {
  categoria: "APP CAMERIERE",
  titolo: "Panoramica App Cameriere",
  descrizione:
    "Controlla i tavoli, gestisci gli ordini e ricevi in tempo reale gli avvisi utili durante il servizio.",
},

"cameriere-installazione": {
  categoria: "APP CAMERIERE",
  titolo: "Installazione",
  descrizione:
    "Installa l'App Cameriere sul dispositivo e accedi utilizzando il QR personale assegnato dal gestore.",
},

"cameriere-utilizzo": {
  categoria: "APP CAMERIERE",
  titolo: "Gestione del servizio",
  descrizione:
    "Apri i tavoli, consulta gli ordini e inserisci nuovi piatti direttamente dall'App Cameriere.",
},

"cameriere-notifiche": {
  categoria: "APP CAMERIERE",
  titolo: "Notifiche e avvisi",
  descrizione:
    "Ricevi gli avvisi relativi ai piatti pronti e alle attività che richiedono l'intervento del cameriere.",
},

"cameriere-standby": {
  categoria: "APP CAMERIERE",
  titolo: "Standby",
  descrizione:
    "Metti temporaneamente in pausa il cameriere quando non deve ricevere notifiche durante il servizio.",
},

  "cucina-introduzione": {
    categoria: "APP CUCINA",
    titolo: "Panoramica App Cucina",
    descrizione:
      "Scopri l'interfaccia utilizzata dalla cucina per ricevere e gestire gli ordini.",
  },

  "cucina-installazione": {
    categoria: "APP CUCINA",
    titolo: "Installazione App Cucina",
    descrizione:
      "Come installare l'app sul dispositivo utilizzato in cucina.",
  },

  "cucina-ordini": {
    categoria: "APP CUCINA",
    titolo: "Gestione ordini",
    descrizione:
      "Ricezione, preparazione e gestione degli ordini in cucina.",
  },

  "cucina-stampa": {
    categoria: "APP CUCINA",
    titolo: "Stampa ordini",
    descrizione:
      "Come utilizzare le funzioni di stampa disponibili nell'App Cucina.",
  },

  "qrprint-introduzione": {
    categoria: "QRPRINT",
    titolo: "Cos'è QrPrint",
    descrizione:
      "QrPrint collega QrMenu alla stampante utilizzata per gli ordini.",
  },

  "qrprint-installazione": {
    categoria: "QRPRINT",
    titolo: "Installazione QrPrint",
    descrizione:
      "Procedura guidata per installare QrPrint sul dispositivo.",
  },

  "qrprint-configurazione": {
    categoria: "QRPRINT",
    titolo: "Configurazione QrPrint",
    descrizione:
      "Configura correttamente QrPrint per il tuo locale.",
  },

  "qrprint-stampante": {
    categoria: "QRPRINT",
    titolo: "Collegamento stampante",
    descrizione:
      "Ricerca, collega e verifica la stampante utilizzata dal locale.",
  },

  "qrprint-automatica": {
    categoria: "QRPRINT",
    titolo: "Stampa automatica",
    descrizione:
      "Configura la stampa automatica dei nuovi ordini ricevuti.",
  },

  "qrprint-problemi": {
    categoria: "QRPRINT",
    titolo: "Problemi comuni",
    descrizione:
      "Soluzioni rapide ai problemi più frequenti durante la stampa.",
  },

  faq: {
    categoria: "ASSISTENZA",
    titolo: "Domande frequenti",
    descrizione:
      "Le risposte alle domande più comuni sull'utilizzo di QrMenu.",
  },

  problemi: {
    categoria: "ASSISTENZA",
    titolo: "Risoluzione problemi",
    descrizione:
      "Controlli e soluzioni per risolvere rapidamente i problemi più comuni.",
  },
};

function ManualeQrMenu() {
  const [sezioneAttiva, setSezioneAttiva] = useState("benvenuto");
  const [menuMobileAperto, setMenuMobileAperto] = useState(false);
  const [ricerca, setRicerca] = useState("");
const [cronologia, setCronologia] = useState(["benvenuto"]);
 const [gruppiAperti, setGruppiAperti] = useState({
  introduzione: true,
  gestore: false,
  cameriere: false,
  cucina: false,
  qrprint: false,
  assistenza: false,
});

  const contenuto = contenuti[sezioneAttiva] || contenuti.benvenuto;

   const livelloSuperiore =
  sezioneAttiva.startsWith("menu-")
    ? { id: "menu", titolo: "Gestione Menu" }
        : sezioneAttiva.startsWith("ordini-")
    ? { id: "ordini", titolo: "Ordini" }
   : sezioneAttiva.startsWith("cassa-")
? { id: "cassa", titolo: "Cassa" }
: sezioneAttiva.startsWith("asporto-")
? { id: "asporto", titolo: "Gestione Asporto" }
: sezioneAttiva.startsWith("camerieri-")
? { id: "camerieri", titolo: "Gestione Camerieri" }
: sezioneAttiva.startsWith("assistente-ai-")
? { id: "assistente-ai", titolo: "Assistente AI" }
: sezioneAttiva.startsWith("sala-")
? { id: "sala", titolo: "Sala in tempo reale" }
: sezioneAttiva.startsWith("promozioni-")
? { id: "promozioni", titolo: "Promozioni" }
: sezioneAttiva.startsWith("cameriere-")
    ? { id: "cameriere-introduzione", titolo: "App Cameriere" }
    : sezioneAttiva.startsWith("cucina-")
    ? { id: "cucina-introduzione", titolo: "App Cucina" }
    : sezioneAttiva.startsWith("qrprint-")
    ? { id: "qrprint-introduzione", titolo: "QrPrint" }
    : null;

  const sezioniFiltrate = useMemo(() => {
    const termine = ricerca.trim().toLowerCase();

    if (!termine) return sezioniManuale;

    return sezioniManuale
      .map((gruppo) => {
        const gruppoCorrisponde = gruppo.titolo
          .toLowerCase()
          .includes(termine);

        const voci = gruppo.voci.filter((voce) => {
          const dati = contenuti[voce.id];

          return (
            voce.titolo.toLowerCase().includes(termine) ||
            dati?.titolo?.toLowerCase().includes(termine) ||
            dati?.descrizione?.toLowerCase().includes(termine) ||
            dati?.categoria?.toLowerCase().includes(termine)
          );
        });

        if (gruppoCorrisponde) {
          return gruppo;
        }

        if (voci.length > 0) {
          return { ...gruppo, voci };
        }

        return null;
      })
      .filter(Boolean);
  }, [ricerca]);

const selezionaVoce = (id) => {
  if (id === sezioneAttiva) {
    setMenuMobileAperto(false);
    return;
  }

  setCronologia((prev) => [...prev, id]);
  setSezioneAttiva(id);
  setMenuMobileAperto(false);

  window.scrollTo({
    top: 0,
    behavior: "smooth",
  });
};

const tornaIndietro = () => {
  setCronologia((prev) => {
    if (prev.length <= 1) {
      setSezioneAttiva("benvenuto");
      return ["benvenuto"];
    }

    const nuovaCronologia = prev.slice(0, -1);
    const precedente = nuovaCronologia[nuovaCronologia.length - 1];

    setSezioneAttiva(precedente);

    window.scrollTo({
      top: 0,
      behavior: "smooth",
    });

    return nuovaCronologia;
  });
};

  const toggleGruppo = (id) => {
    setGruppiAperti((prev) => ({
      ...prev,
      [id]: !prev[id],
    }));
  };

  return (
    <div className="manuale-page">
      <header className="manuale-header">
        <div className="manuale-header-inner">
 <div className="manuale-brand">
  <img
    src={logo}
    alt="QrMenu"
    className="manuale-brand-logo"
  />

  <div>
    <div className="manuale-brand-name">QrMenu</div>
    <div className="manuale-brand-subtitle">Manuale Operativo</div>
  </div>
</div>

          <div className="manuale-search">
            <span className="manuale-search-icon">⌕</span>
            <input
              type="text"
              value={ricerca}
              onChange={(e) => setRicerca(e.target.value)}
              placeholder="Cerca nel manuale..."
              aria-label="Cerca nel manuale"
            />
          </div>

          <button
            className="manuale-mobile-button"
            onClick={() => setMenuMobileAperto((prev) => !prev)}
            aria-label="Apri menu manuale"
          >
            {menuMobileAperto ? "✕" : "☰"}
          </button>
        </div>
      </header>

      <div className="manuale-layout">
        <aside
          className={`manuale-sidebar ${
            menuMobileAperto ? "manuale-sidebar-open" : ""
          }`}
        >
          <div className="manuale-sidebar-scroll">
            <div className="manuale-sidebar-title">GUIDA QRMENU</div>

            {sezioniFiltrate.length === 0 && (
              <div className="manuale-no-results">
                Nessun risultato trovato.
              </div>
            )}

            {sezioniFiltrate.map((gruppo) => {
              const aperto = ricerca
                ? true
                : gruppiAperti[gruppo.id] !== false;

              return (
                <div className="manuale-nav-group" key={gruppo.id}>
                  <button
                    className="manuale-nav-group-title"
                    onClick={() => toggleGruppo(gruppo.id)}
                  >
                    <span className="manuale-nav-group-label">
                      <span>{gruppo.icona}</span>
                      {gruppo.titolo}
                    </span>

                    <span className="manuale-chevron">
                      {aperto ? "⌄" : "›"}
                    </span>
                  </button>

                  {aperto && (
                    <div className="manuale-nav-items">
                      {gruppo.voci.map((voce) => (
                        <button
                          key={voce.id}
                          className={`manuale-nav-item ${
                            sezioneAttiva === voce.id ? "active" : ""
                          }`}
                          onClick={() => selezionaVoce(voce.id)}
                        >
                          {voce.titolo}
                        </button>
                      ))}
                    </div>
                  )}
                </div>
              );
            })}
          </div>
        </aside>

        {menuMobileAperto && (
          <div
            className="manuale-mobile-overlay"
            onClick={() => setMenuMobileAperto(false)}
          />
        )}

        <main className="manuale-content">
          <div className="manuale-content-inner">
          <div className="manuale-navigation">
  <button
    className="manuale-back-button"
    onClick={tornaIndietro}
    disabled={cronologia.length <= 1}
  >
    ← Indietro
  </button>

  <div className="manuale-breadcrumb">
    <button onClick={() => selezionaVoce("benvenuto")}>
      Manuale QrMenu
    </button>

    {livelloSuperiore && (
      <>
        <span>›</span>

        <button onClick={() => selezionaVoce(livelloSuperiore.id)}>
          {livelloSuperiore.titolo}
        </button>
      </>
    )}

    <span>›</span>

    <span className="manuale-breadcrumb-current">
      {contenuto.titolo}
    </span>
  </div>
</div>

            <div className="manuale-hero">
              <div className="manuale-eyebrow">{contenuto.categoria}</div>

              <h1>{contenuto.titolo}</h1>

              <p>{contenuto.descrizione}</p>
            </div>

{contenuto.tipo === "benvenuto" ? (
  <Benvenuto selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "come-funziona" ? (
  <ComeFunzionaQrMenu selezionaVoce={selezionaVoce} />
) : contenuto.tipo === "dashboard" ? (
  <DashboardIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "menu" ? (
  <GestioneMenuIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "menu-categorie" ? (
  <GestioneCategorie />
) : sezioneAttiva === "menu-aggiungi" ? (
  <AggiungerePiatto />
) : sezioneAttiva === "menu-modifica" ? (
  <ModificarePiatto />
) : sezioneAttiva === "menu-ordinamento" ? (
  <OrdinarePiatti />
) : sezioneAttiva === "menu-visibilita" ? (
  <VisibilitaPiatti />
) : sezioneAttiva === "menu-promozioni" ? (
  <PromozioniPiatti />
) : sezioneAttiva === "menu-foto" ? (
  <FotoImmaginiAI />
) : sezioneAttiva === "menu-traduzioni" ? (
  <TraduzioniAI />
) : sezioneAttiva === "menu-suggerimenti" ? (
  <SuggerimentiAI />
) : sezioneAttiva === "ordini" ? (
  <OrdiniIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "ordini-panoramica" ? (
  <OrdiniPanoramica />
) : sezioneAttiva === "ordini-filtri" ? (
  <OrdiniFiltri />
) : sezioneAttiva === "ordini-stati" ? (
  <OrdiniStati />
) : sezioneAttiva === "ordini-modifica" ? (
  <OrdiniModifica />
) : sezioneAttiva === "ordini-elimina" ? (
  <OrdiniElimina />
) : sezioneAttiva === "cassa" ? (
  <CassaIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "cassa-panoramica" ? (
  <CassaPanoramica />
) : sezioneAttiva === "cassa-filtri" ? (
  <CassaFiltri />
) : sezioneAttiva === "cassa-pagamento" ? (
  <CassaPagamento />
) : sezioneAttiva === "cassa-coperti" ? (
  <CassaCoperti />
) : sezioneAttiva === "cassa-pagati" ? (
  <CassaPagati />
) : sezioneAttiva === "cassa-chiusura" ? (
  <CassaChiusura />
) : sezioneAttiva === "asporto" ? (
  <AsportoIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "asporto-qr" ? (
  <AsportoQr />
) : sezioneAttiva === "asporto-reset" ? (
  <AsportoReset />
) : sezioneAttiva === "asporto-slot" ? (
  <AsportoSlot />
) : sezioneAttiva === "camerieri" ? (
  <GestioneCamerieriIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "camerieri-installazione" ? (
  <CamerieriInstallazione />
) : sezioneAttiva === "camerieri-aggiungi" ? (
  <CamerieriAggiungi />
) : sezioneAttiva === "camerieri-accesso" ? (
  <CamerieriAccesso />
) : sezioneAttiva === "camerieri-notifiche" ? (
  <CamerieriNotifiche />
) : sezioneAttiva === "camerieri-standby" ? (
  <CamerieriStandby />
) : sezioneAttiva === "camerieri-elimina" ? (
  <CamerieriElimina />
) : sezioneAttiva === "assistente-ai" ? (
  <AssistenteAIIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "assistente-ai-simulazione" ? (
  <AssistenteAISimulazione />
) : sezioneAttiva === "assistente-ai-upselling" ? (
  <AssistenteAIUpselling />
) : sezioneAttiva === "assistente-ai-regole" ? (
  <AssistenteAIRegole selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "assistente-ai-strategia" ? (
  <AssistenteAIStrategia />
) : sezioneAttiva === "assistente-ai-prioritari" ? (
  <AssistenteAIPrioritari />
) : sezioneAttiva === "assistente-ai-suggerimenti" ? (
  <AssistenteAISuggerimenti />
) : sezioneAttiva === "assistente-ai-sala" ? (
  <AssistenteAISala />
) : sezioneAttiva === "sala" ? (
  <SalaIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "sala-stati" ? (
  <SalaStati />
) : sezioneAttiva === "sala-occupato" ? (
  <SalaOccupato />
) : sezioneAttiva === "sala-nuovo-ordine" ? (
  <SalaNuovoOrdine />
) : sezioneAttiva === "sala-concludi" ? (
  <SalaConcludi />
) : sezioneAttiva === "sala-alert" ? (
  <SalaAlert />
) : sezioneAttiva === "promozioni" ? (
  <PromozioniIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "promozioni-popup" ? (
  <PromozioniPopup />
) : sezioneAttiva === "chiamate" ? (
  <ChiamateServizio />
) : sezioneAttiva === "report" ? (
  <ReportGestore />
) : sezioneAttiva === "cameriere-introduzione" ? (
  <CamerierePanoramica selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "cameriere-installazione" ? (
  <CameriereInstallazione />
) : sezioneAttiva === "cameriere-utilizzo" ? (
  <CameriereUtilizzo />
) : sezioneAttiva === "cameriere-notifiche" ? (
  <CameriereNotifiche />
) : sezioneAttiva === "cameriere-standby" ? (
  <CameriereStandby />
) : sezioneAttiva === "cucina-introduzione" ? (
  <CucinaIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "cucina-installazione" ? (
  <CucinaInstallazione />
) : sezioneAttiva === "cucina-ordini" ? (
  <CucinaGestioneOrdini />
) : sezioneAttiva === "cucina-stampa" ? (
  <CucinaStampaOrdini selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "qrprint-introduzione" ? (
  <QrPrintIntro selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "qrprint-installazione" ? (
  <QrPrintInstallazione />
) : sezioneAttiva === "qrprint-configurazione" ? (
  <QrPrintConfigurazione />
) : sezioneAttiva === "qrprint-stampante" ? (
  <QrPrintStampante />
) : sezioneAttiva === "qrprint-automatica" ? (
  <QrPrintAutomatica />
) : sezioneAttiva === "qrprint-problemi" ? (
  <QrPrintProblemi />
) : sezioneAttiva === "faq" ? (
  <DomandeFrequenti selezionaVoce={selezionaVoce} />
) : sezioneAttiva === "problemi" ? (
  <RisoluzioneProblemi selezionaVoce={selezionaVoce} />
) : (
  <ContenutoInPreparazione />
)}
          </div>

          <footer className="manuale-footer">
            <span>QrMenu</span>
            <span>Manuale Operativo</span>
          </footer>
        </main>
      </div>
    </div>
  );
}

function Benvenuto({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-card manuale-welcome-card">
        <div className="manuale-card-icon">👋</div>

        <div>
          <h2>Tutto quello che ti serve per utilizzare QrMenu</h2>

          <p>
            Questa guida ti accompagnerà nell'utilizzo delle funzioni dedicate
            al gestore, al personale di sala e alla cucina, compresa la
            configurazione del sistema di stampa QrPrint.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Da dove vuoi iniziare?</h2>

        <p className="manuale-section-intro">
          Scegli un'area oppure utilizza la ricerca in alto per trovare
          rapidamente una funzione.
        </p>

        <div className="manuale-start-grid">
          <button
            className="manuale-start-card"
            onClick={() => selezionaVoce("dashboard")}
          >
            <span className="manuale-start-icon">👤</span>
            <strong>Gestore</strong>
            <span>Dashboard, menu, ordini, cassa, AI e report.</span>
            <b>Apri la guida →</b>
          </button>

          <button
            className="manuale-start-card"
            onClick={() => selezionaVoce("cameriere-introduzione")}
          >
            <span className="manuale-start-icon">🛎️</span>
            <strong>Cameriere</strong>
            <span>Installazione, utilizzo e notifiche.</span>
            <b>Apri la guida →</b>
          </button>

          <button
            className="manuale-start-card"
            onClick={() => selezionaVoce("cucina-introduzione")}
          >
            <span className="manuale-start-icon">👨‍🍳</span>
            <strong>Cucina</strong>
            <span>Ordini, preparazione e stampa.</span>
            <b>Apri la guida →</b>
          </button>

          <button
            className="manuale-start-card"
            onClick={() => selezionaVoce("qrprint-introduzione")}
          >
            <span className="manuale-start-icon">🖨️</span>
            <strong>QrPrint</strong>
            <span>Installazione e configurazione della stampante.</span>
            <b>Apri la guida →</b>
          </button>
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Una guida sempre aggiornata</strong>
          <p>
            Il manuale online viene aggiornato insieme alle funzionalità di
            QrMenu, così puoi consultare sempre le istruzioni più recenti.
          </p>
        </div>
      </section>
    </>
  );
}
function ComeFunzionaQrMenu({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Un unico sistema per cliente, sala, cucina e gestore</h2>

        <p>
          QrMenu collega in tempo reale le principali attività del locale.
          Il cliente consulta il menu e invia gli ordini, la cucina gestisce
          la preparazione, il personale di sala riceve gli avvisi e il gestore
          controlla l'intero servizio dalla propria Dashboard.
        </p>
      </section>

      <section className="manuale-section">
        <h2>1. Il cliente consulta il menu</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Scansione del QR Code"
            testo="Il cliente scansiona il QR Code del tavolo e apre il menu digitale sul proprio smartphone."
          />

          <ManualeStep
            numero="2"
            titolo="Consulta il menu"
            testo="Il cliente può visualizzare categorie, piatti, descrizioni, ingredienti, allergeni, immagini e le altre informazioni configurate dal locale."
          />

          <ManualeStep
            numero="3"
            titolo="Invia l'ordine"
            testo="Dopo aver scelto i piatti, il cliente può inviare l'ordine direttamente dal menu digitale."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📱</span>

        <div>
          <strong>Nessuna app da installare per il cliente</strong>

          <p>
            Il menu viene aperto direttamente dal QR Code sul dispositivo
            del cliente.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>2. L'ordine arriva alla cucina</h2>

        <p>
          Gli ordini inviati vengono resi disponibili nell'App Cucina,
          dove il personale può seguirne la preparazione.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Ricezione dell'ordine"
            testo="La cucina riceve i nuovi ordini in tempo reale."
          />

          <ManualeStep
            numero="2"
            titolo="Preparazione"
            testo="I piatti possono essere gestiti attraverso gli stati disponibili, ad esempio In attesa, In preparazione e Pronto."
          />

          <ManualeStep
            numero="3"
            titolo="Gestione piatto per piatto"
            testo="Quando necessario, la cucina può aggiornare anche singoli piatti della comanda senza modificare contemporaneamente tutto l'ordine."
          />
        </div>

        <button
          className="manuale-inline-link"
          onClick={() => selezionaVoce("cucina-introduzione")}
        >
          Apri la guida App Cucina →
        </button>
      </section>

      <section className="manuale-section">
        <h2>3. Il cameriere segue il servizio</h2>

        <p>
          L'App Cameriere mantiene il personale di sala aggiornato
          sulle attività che richiedono attenzione.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controllo dei tavoli"
            testo="Il cameriere può consultare lo stato dei tavoli e aprire quelli sui quali deve intervenire."
          />

          <ManualeStep
            numero="2"
            titolo="Piatti pronti"
            testo="Quando la cucina imposta i piatti della sala come Pronto, QrMenu può avvisare il personale di sala."
          />

          <ManualeStep
            numero="3"
            titolo="Chiamate di servizio"
            testo="Le richieste di assistenza effettuate dal cliente vengono mostrate in tempo reale anche nell'App Cameriere."
          />

          <ManualeStep
            numero="4"
            titolo="Inserimento ordini"
            testo="Il cameriere può inoltre aprire un tavolo e inserire direttamente nuovi piatti quando necessario."
          />
        </div>

        <button
          className="manuale-inline-link"
          onClick={() => selezionaVoce("cameriere-introduzione")}
        >
          Apri la guida App Cameriere →
        </button>
      </section>

      <section className="manuale-section">
        <h2>4. Il gestore controlla il locale</h2>

        <p>
          La Dashboard Gestore raccoglie le principali funzioni di
          amministrazione e controllo operativo di QrMenu.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Menu"
            testo="Il gestore crea e modifica categorie e piatti e controlla ciò che viene mostrato al cliente."
          />

          <ManualeStep
            numero="2"
            titolo="Ordini e sala"
            testo="Può consultare gli ordini, controllare la sala in tempo reale e intervenire sui tavoli."
          />

          <ManualeStep
            numero="3"
            titolo="Cassa"
            testo="Gestisce i pagamenti, i coperti e gli ordini già pagati."
          />

          <ManualeStep
            numero="4"
            titolo="Asporto"
            testo="Configura il menu da asporto, la numerazione degli ordini e gli eventuali slot orari."
          />

          <ManualeStep
            numero="5"
            titolo="Intelligenza Artificiale"
            testo="Può configurare le funzioni AI disponibili, comprese strategie, suggerimenti e AI Sala."
          />

          <ManualeStep
            numero="6"
            titolo="Analisi performance"
            testo="Consulta KPI, vendite, tempi operativi e storico degli ordini."
          />
        </div>

        <button
          className="manuale-inline-link"
          onClick={() => selezionaVoce("dashboard")}
        >
          Apri la guida Dashboard Gestore →
        </button>
      </section>

      <section className="manuale-section">
        <h2>5. Stampa delle comande con QrPrint</h2>

        <p>
          Se il locale utilizza una stampante termica compatibile,
          QrPrint permette all'App Cucina di inviare le comande
          alla stampante.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Stampa manuale"
            testo="La cucina può inviare manualmente alla stampante una comanda."
          />

          <ManualeStep
            numero="2"
            titolo="Stampa automatica"
            testo="Quando la funzione è abilitata per il locale, i nuovi ordini possono essere inviati automaticamente a QrPrint."
          />

          <ManualeStep
            numero="3"
            titolo="Rete locale"
            testo="Il dispositivo utilizzato per l'App Cucina e la stampante devono essere collegati alla stessa rete Wi-Fi."
          />
        </div>

        <button
          className="manuale-inline-link"
          onClick={() => selezionaVoce("qrprint-introduzione")}
        >
          Apri la guida QrPrint →
        </button>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔄</span>

        <div>
          <strong>Aggiornamento in tempo reale</strong>

          <p>
            Le diverse aree di QrMenu comunicano tra loro durante il servizio.
            Quando cambia lo stato di un ordine, di un piatto o di una
            richiesta, le postazioni interessate possono ricevere
            l'aggiornamento senza dover gestire sistemi separati.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Il flusso in breve</strong>

          <p>
            Cliente ordina → Cucina prepara → Cameriere viene avvisato →
            Gestore controlla servizio, incasso e performance.
          </p>
        </div>
      </section>
    </>
  );
}

function DashboardIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Il centro di controllo del tuo locale</h2>

        <p>
          La Dashboard Gestore è il punto di accesso alle principali funzioni
          operative di QrMenu.
        </p>

        <p>
          Da questa schermata puoi controllare il menu, gli ordini, la cassa,
          l'asporto, la cucina, le funzioni di Intelligenza Artificiale e lo
          stato della sala in tempo reale.
        </p>
      </section>

     
      <section className="manuale-section">
        <h2>Funzioni principali</h2>

        <div className="manuale-feature-grid">
          <button onClick={() => selezionaVoce("menu")}>
            <span>🍽️</span>
            <div>
              <strong>Menu</strong>
              <small>Configura e personalizza il menu digitale</small>
            </div>
          </button>

          <button onClick={() => selezionaVoce("ordini")}>
            <span>📦</span>
            <div>
              <strong>Ordini</strong>
              <small>Visualizza e controlla gli ordini ricevuti</small>
            </div>
          </button>

          <button onClick={() => selezionaVoce("cassa")}>
            <span>💳</span>
            <div>
              <strong>Cassa</strong>
              <small>Gestione dei pagamenti e degli incassi</small>
            </div>
          </button>
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Accesso rapido</strong>
          <p>
            Seleziona una funzione nella Dashboard oppure utilizza il menu
            laterale di questa guida per aprire direttamente le relative
            istruzioni.
          </p>
        </div>
      </section>

   

      <section className="manuale-section">
        <h2>Gestione operativa</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="👨‍🍳"
            titolo="App Cucina"
            testo="Permette di accedere alle funzioni dedicate alla cucina e alla gestione operativa degli ordini."
            onClick={() => selezionaVoce("cucina-introduzione")}
          />

          <ManualeDashboardItem
            icona="📦"
            titolo="Controllo ordini"
            testo="Consente di visualizzare e controllare gli ordini ricevuti dal locale."
            onClick={() => selezionaVoce("ordini")}
          />

          <ManualeDashboardItem
            icona="👨‍🍳"
            titolo="Flusso cucina"
            testo="Permette di seguire l'avanzamento degli ordini durante il servizio."
            onClick={() => selezionaVoce("cucina-ordini")}
          />

          <ManualeDashboardItem
            icona="💳"
            titolo="Incassi e pagamenti"
            testo="Apre le funzioni dedicate alla cassa, agli incassi e ai pagamenti."
            onClick={() => selezionaVoce("cassa")}
          />

          <ManualeDashboardItem
            icona="📱"
            titolo="Gestione Asporto"
            testo="Permette di accedere alle funzioni dedicate agli ordini da asporto."
            onClick={() => selezionaVoce("asporto")}
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Assistente AI</h2>

        <p>
          L'area Assistente AI raccoglie le funzioni di Intelligenza
          Artificiale messe a disposizione del gestore.
        </p>

        <div className="manuale-feature-grid">
          <button onClick={() => selezionaVoce("assistente-ai-simulazione")}>
            <span>🤖</span>
            <div>
              <strong>Simula esperienza cliente</strong>
              <small>
                Verifica l'esperienza e i suggerimenti mostrati al cliente
              </small>
            </div>
          </button>

          <button onClick={() => selezionaVoce("assistente-ai-regole")}>
            <span>⚙️</span>
            <div>
              <strong>Regole AI</strong>
              <small>
                Configura le regole utilizzate dall'Intelligenza Artificiale
              </small>
            </div>
          </button>

          <button onClick={() => selezionaVoce("assistente-ai-sala")}>
            <span>🤖</span>
            <div>
              <strong>AI Sala</strong>
              <small>
                Configura le funzioni intelligenti dedicate alla sala
              </small>
            </div>
          </button>
        </div>
      </section>

   

      <section className="manuale-section">
        <h2>Chiamate di servizio</h2>

        <p>
          Quando un cliente invia una richiesta di servizio dal tavolo, la
          Dashboard mostra una notifica nella sezione
          <strong> Chiamate Servizio</strong>.
        </p>

        <p>
          Il numero tra parentesi indica quante richieste risultano attive.
          Ogni richiesta identifica il tavolo che ha effettuato la chiamata,
          permettendo al personale di intervenire rapidamente.
        </p>

        <button
          className="manuale-inline-link"
          onClick={() => selezionaVoce("chiamate")}
        >
          Apri la guida alle Chiamate di servizio →
        </button>
      </section>

      <section className="manuale-section">
        <h2>Sala in tempo reale</h2>

        <p>
          Questa area offre al gestore una panoramica immediata dello stato dei
          tavoli e dell'attività della sala.
        </p>

        <p>
          I tavoli vengono rappresentati attraverso colori differenti per
          permettere di riconoscere rapidamente il loro stato durante il
          servizio.
        </p>

        <button
          className="manuale-inline-link"
          onClick={() => selezionaVoce("sala")}
        >
          Apri la guida alla Sala in tempo reale →
        </button>
      </section>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Configurazione dei tavoli</strong>
          <p>
            La creazione dei tavoli e la generazione dei relativi QR Code
            vengono effettuate dall'amministratore e non fanno parte delle
            operazioni descritte in questo manuale.
          </p>
        </div>
      </section>
    </>
  );
}

function GestioneMenuIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestisci il tuo menu digitale</h2>

        <p>
          Da questa sezione puoi organizzare categorie e piatti, modificare
          ciò che viene mostrato ai clienti e utilizzare le funzioni di
          Intelligenza Artificiale integrate in QrMenu.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Gestione menu</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="📁"
            titolo="Gestisci categorie"
            testo="Crea e organizza le categorie utilizzate per suddividere i piatti."
            onClick={() => selezionaVoce("menu-categorie")}
          />

          <ManualeDashboardItem
            icona="➕"
            titolo="Aggiungi piatto"
            testo="Inserisci un nuovo piatto con nome, prezzo, categoria, descrizione, ingredienti, allergeni e immagine."
            onClick={() => selezionaVoce("menu-aggiungi")}
          />

          <ManualeDashboardItem
            icona="↕️"
            titolo="Ordina i piatti"
            testo="Modifica l'ordine con cui i piatti vengono mostrati all'interno del menu."
            onClick={() => selezionaVoce("menu-ordinamento")}
          />

          <ManualeDashboardItem
            icona="👁️"
            titolo="Visibilità piatti"
            testo="Mostra o nascondi rapidamente un piatto dal menu del cliente."
            onClick={() => selezionaVoce("menu-visibilita")}
          />

          <ManualeDashboardItem
            icona="✨"
            titolo="Promozioni"
            testo="Accedi alle funzioni promozionali disponibili per i singoli piatti."
            onClick={() => selezionaVoce("menu-promozioni")}
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Intelligenza artificiale</h2>

        <p>
          QrMenu mette a disposizione del gestore alcune funzioni AI
          direttamente all'interno della gestione del menu.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="💳"
            titolo="Crediti"
            testo="Visualizza i crediti disponibili per utilizzare le funzioni di Intelligenza Artificiale."
            onClick={() => selezionaVoce("assistente-ai")}
          />

          <ManualeDashboardItem
            icona="🤖"
            titolo="Traduci con AI"
            testo="Traduci piatti, categorie e testi dell'interfaccia utilizzando l'Intelligenza Artificiale."
            onClick={() => selezionaVoce("menu-traduzioni")}
          />

          <ManualeDashboardItem
            icona="📷"
            titolo="Foto"
            testo="Attiva o disattiva la visualizzazione delle immagini dei piatti."
            onClick={() => selezionaVoce("menu-foto")}
          />

          <ManualeDashboardItem
            icona="✨"
            titolo="Suggerimenti"
            testo="Attiva o disattiva i suggerimenti intelligenti disponibili nel menu."
            onClick={() => selezionaVoce("menu-suggerimenti")}
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Gestione rapida</strong>
          <p>
            Puoi utilizzare i filtri delle categorie per visualizzare
            rapidamente soltanto i piatti appartenenti alla sezione del menu
            che vuoi gestire.
          </p>
        </div>
      </section>
    </>
  );
}

function GestioneCategorie() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire le categorie del menu</h2>

        <p>
          Le categorie permettono di organizzare i piatti nelle diverse
          sezioni del menu, ad esempio Antipasti, Primi, Pizze, Dolci
          e Bevande.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Aggiungi una categoria"
          testo="Scrivi il nome nel campo Nuova categoria e premi Aggiungi categoria."
        />

        <ManualeStep
          numero="2"
          titolo="Cambia l'ordine"
          testo="Utilizza i pulsanti ↑ e ↓ accanto alla categoria per spostarla e modificare l'ordine con cui viene mostrata nel menu."
        />

        <ManualeStep
          numero="3"
          titolo="Mostra o nascondi una categoria"
          testo="Utilizza il pulsante con l'icona dell'occhio per gestire la visibilità della categoria."
        />

        <ManualeStep
          numero="4"
          titolo="Modifica il nome"
          testo="Premi Modifica, cambia il nome della categoria e premi Salva. Se non vuoi applicare la modifica premi Annulla."
        />

        <ManualeStep
          numero="5"
          titolo="Elimina una categoria"
          testo="Premi Elimina sulla categoria che vuoi rimuovere."
        />
      </div>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Ordine delle categorie</strong>
          <p>
            Usa le frecce ↑ e ↓ per organizzare le categorie nello stesso
            ordine in cui vuoi presentarle ai clienti nel menu.
          </p>
        </div>
      </section>
    </>
  );
}

function AggiungerePiatto() {
  return (
    <>
      <section className="manuale-section">
        <h2>Come aggiungere un nuovo piatto</h2>

        <p>
          Dalla Gestione Menu premi il pulsante
          <strong> + Aggiungi piatto</strong>. Si aprirà la schermata
          nella quale inserire tutte le informazioni del nuovo piatto.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Inserisci nome e prezzo"
          testo="Indica il nome del piatto e il relativo prezzo."
        />

        <ManualeStep
          numero="2"
          titolo="Seleziona la categoria"
          testo="Scegli la categoria del menu nella quale deve essere inserito il piatto."
        />

        <ManualeStep
          numero="3"
          titolo="Indica gli allergeni"
          testo="Seleziona gli allergeni presenti nel piatto tra quelli disponibili."
        />

        <ManualeStep
          numero="4"
          titolo="Aggiungi descrizione e ingredienti"
          testo="Inserisci una descrizione del piatto e specifica gli ingredienti."
        />

        <ManualeStep
          numero="5"
          titolo="Aggiungi l'immagine"
          testo="Puoi caricare una fotografia del piatto oppure utilizzare la funzione Genera con AI."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✨</span>

        <div>
          <strong>Genera con AI</strong>
          <p>
            Se non disponi di una fotografia puoi utilizzare
            l'Intelligenza Artificiale di QrMenu per generare
            un'immagine del piatto.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>⚠️</span>

        <div>
          <strong>Controlla sempre gli allergeni</strong>
          <p>
            Prima di completare l'inserimento verifica attentamente
            che gli allergeni indicati corrispondano a quelli
            effettivamente presenti nel piatto.
          </p>
        </div>
      </section>
    </>
  );
}

function ModificarePiatto() {
  return (
    <>
      <section className="manuale-section">
        <h2>Come modificare un piatto</h2>

        <p>
          Seleziona il piatto che vuoi aggiornare. Si aprirà la schermata
          <strong> Modifica piatto</strong>, dalla quale puoi modificare
          le informazioni già presenti.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Modifica nome e prezzo"
          testo="Aggiorna il nome del piatto oppure modifica il prezzo."
        />

        <ManualeStep
          numero="2"
          titolo="Cambia categoria"
          testo="Utilizza il menu Categoria per spostare il piatto in un'altra categoria del menu."
        />

        <ManualeStep
          numero="3"
          titolo="Aggiorna ingredienti e descrizione"
          testo="Modifica gli ingredienti oppure la descrizione mostrata nel menu."
        />

        <ManualeStep
          numero="4"
          titolo="Sostituisci l'immagine"
          testo="Puoi scegliere una nuova immagine dal dispositivo oppure utilizzare Genera con AI per crearne una nuova."
        />

        <ManualeStep
          numero="5"
          titolo="Salva le modifiche"
          testo="Quando hai terminato premi Salva per applicare le modifiche al piatto."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✨</span>

        <div>
          <strong>Genera con AI</strong>
          <p>
            Puoi utilizzare i crediti AI Immagini disponibili per generare
            una nuova immagine del piatto direttamente dalla schermata
            di modifica.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>🗑️</span>

        <div>
          <strong>Cancellare un piatto</strong>
          <p>
            Il pulsante Cancella permette di eliminare il piatto.
            Utilizzalo solamente quando vuoi rimuovere definitivamente
            il piatto dal menu.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>✕</span>

        <div>
          <strong>Annullare le modifiche</strong>
          <p>
            Premi Annulla se vuoi uscire dalla modifica senza salvare
            i cambiamenti effettuati.
          </p>
        </div>
      </section>
    </>
  );
}

function OrdinarePiatti() {
  return (
    <>
      <section className="manuale-section">
        <h2>Come cambiare l'ordine dei piatti</h2>

        <p>
          Dalla Gestione Menu puoi modificare l'ordine con cui i piatti
          vengono presentati all'interno della propria categoria.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il piatto"
          testo="Trova nella Gestione Menu il piatto che vuoi spostare."
        />

        <ManualeStep
          numero="2"
          titolo="Usa le frecce"
          testo="Utilizza i pulsanti ↑ e ↓ presenti sulla scheda del piatto per modificarne la posizione."
        />

        <ManualeStep
          numero="3"
          titolo="Continua fino alla posizione desiderata"
          testo="Premi più volte la freccia verso l'alto o verso il basso fino a portare il piatto nella posizione desiderata."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">↕️</span>

        <div>
          <strong>Ordine dei piatti</strong>
          <p>
            Le frecce permettono di organizzare rapidamente la posizione
            dei piatti senza doverli eliminare o reinserire.
          </p>
        </div>
      </section>
    </>
  );
}

function VisibilitaPiatti() {
  return (
    <>
      <section className="manuale-section">
        <h2>Mostrare o nascondere un piatto</h2>

        <p>
          Dalla Gestione Menu puoi decidere rapidamente quali piatti
          mostrare ai clienti senza doverli eliminare.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il piatto"
          testo="Trova nella Gestione Menu il piatto che vuoi mostrare o nascondere."
        />

        <ManualeStep
          numero="2"
          titolo="Utilizza lo switch Visibile"
          testo="Attiva o disattiva lo switch Visibile presente nella scheda del piatto."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla lo stato"
          testo="Quando lo switch è attivo, il piatto viene mostrato nel menu. Quando è disattivato, il piatto rimane salvato ma non viene mostrato ai clienti."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Non serve eliminare il piatto</strong>
          <p>
            Questa funzione è utile quando un piatto è temporaneamente
            non disponibile: puoi nasconderlo e renderlo nuovamente
            visibile in qualsiasi momento.
          </p>
        </div>
      </section>
    </>
  );
}

function PromozioniPiatti() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire le promozioni dei piatti</h2>

        <p>
          Dalla Gestione Menu puoi utilizzare il pulsante
          <strong> Promozione</strong> presente nella scheda di ogni piatto
          per accedere alle relative funzioni promozionali.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il piatto"
          testo="Trova nella Gestione Menu il piatto sul quale vuoi impostare una promozione."
        />

        <ManualeStep
          numero="2"
          titolo="Premi Promozione"
          testo="Seleziona il pulsante Promozione presente nella scheda del piatto."
        />

        <ManualeStep
          numero="3"
          titolo="Configura la promozione"
          testo="Imposta le opzioni disponibili nella schermata della promozione."
        />

        <ManualeStep
          numero="4"
          titolo="Salva"
          testo="Conferma le impostazioni per applicare la promozione al piatto."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✨</span>

        <div>
          <strong>Promozioni per singolo piatto</strong>
          <p>
            Le promozioni vengono gestite direttamente dalla scheda del
            piatto, così puoi scegliere quali prodotti mettere in evidenza
            senza modificare gli altri elementi del menu.
          </p>
        </div>
      </section>
    </>
  );
}

function FotoImmaginiAI() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire le immagini dei piatti</h2>

        <p>
          QrMenu permette di utilizzare una fotografia del piatto oppure
          di generare una nuova immagine attraverso l'Intelligenza Artificiale.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri il piatto"
          testo="Seleziona dalla Gestione Menu il piatto al quale vuoi aggiungere o modificare l'immagine."
        />

        <ManualeStep
          numero="2"
          titolo="Carica una fotografia"
          testo="Utilizza il campo Immagine per scegliere una fotografia disponibile sul tuo dispositivo."
        />

        <ManualeStep
          numero="3"
          titolo="Oppure genera con AI"
          testo="Premi Genera con AI per utilizzare l'Intelligenza Artificiale e creare una nuova immagine del piatto."
        />

        <ManualeStep
          numero="4"
          titolo="Controlla l'immagine"
          testo="Verifica l'immagine ottenuta prima di utilizzarla per il piatto."
        />

        <ManualeStep
          numero="5"
          titolo="Salva il piatto"
          testo="Premi Salva per applicare l'immagine scelta al piatto."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✨</span>

        <div>
          <strong>Crediti AI Immagini</strong>
          <p>
            La generazione delle immagini utilizza i crediti AI Immagini
            disponibili per il locale. Il numero di crediti disponibili
            viene mostrato nella schermata di modifica del piatto.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Fotografia o Intelligenza Artificiale</strong>
          <p>
            Se possiedi già una buona fotografia puoi caricarla direttamente.
            La generazione AI è utile quando non disponi di un'immagine
            adatta per il piatto.
          </p>
        </div>
      </section>
    </>
  );
}

function TraduzioniAI() {
  return (
    <>
      <section className="manuale-section">
        <h2>Tradurre il menu con l'Intelligenza Artificiale</h2>

        <p>
          Dalla Gestione Menu premi <strong>Traduci con AI</strong> per
          tradurre automaticamente i contenuti del menu nelle lingue
          disponibili.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri Traduci con AI"
          testo="Dalla Gestione Menu premi il pulsante Traduci con AI nella sezione Intelligenza artificiale."
        />

        <ManualeStep
          numero="2"
          titolo="Scegli cosa tradurre"
          testo="Seleziona Piatti, Categorie oppure Testi UI in base ai contenuti che vuoi tradurre."
        />

        <ManualeStep
          numero="3"
          titolo="Seleziona le lingue"
          testo="Scegli le lingue nelle quali vuoi generare le traduzioni."
        />

        <ManualeStep
          numero="4"
          titolo="Avvia la traduzione"
          testo="Premi Avvia traduzione per iniziare la generazione automatica dei testi."
        />

        <ManualeStep
          numero="5"
          titolo="Attendi il completamento"
          testo="QrMenu elaborerà i contenuti selezionati e salverà le traduzioni generate."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🤖</span>

        <div>
          <strong>Cosa puoi tradurre</strong>
          <p>
            Puoi tradurre i dati dei piatti, i titoli delle categorie
            e i testi dell'interfaccia utilizzata dal cliente.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💳</span>

        <div>
          <strong>Crediti AI Traduzioni</strong>
          <p>
            Le traduzioni generate con l'Intelligenza Artificiale utilizzano
            i crediti AI Traduzioni disponibili per il locale.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Controlla le traduzioni</strong>
          <p>
            Dopo la traduzione è consigliabile verificare i testi generati,
            soprattutto per nomi di piatti, ingredienti e termini
            caratteristici della cucina del locale.
          </p>
        </div>
      </section>
    </>
  );
}

function SuggerimentiAI() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire i suggerimenti AI</h2>

        <p>
          Dalla Gestione Menu puoi attivare o disattivare i suggerimenti
          generati dall'Intelligenza Artificiale per l'esperienza del cliente.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri Gestione Menu"
          testo="Accedi alla sezione Menu dalla Dashboard Gestore."
        />

        <ManualeStep
          numero="2"
          titolo="Individua Suggerimenti"
          testo="Nella sezione Intelligenza artificiale individua la voce Suggerimenti."
        />

        <ManualeStep
          numero="3"
          titolo="Attiva o disattiva"
          testo="Utilizza lo switch accanto a Suggerimenti per abilitare o disabilitare la funzione."
        />

        <ManualeStep
          numero="4"
          titolo="Controlla lo stato"
          testo="Quando lo switch è attivo, i suggerimenti AI sono abilitati. Quando è disattivato, la funzione non viene utilizzata."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✨</span>

        <div>
          <strong>Suggerimenti intelligenti</strong>
          <p>
            Questa funzione permette a QrMenu di utilizzare
            l'Intelligenza Artificiale per proporre suggerimenti
            all'interno dell'esperienza cliente.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Funzione attivabile in qualsiasi momento</strong>
          <p>
            Puoi attivare o disattivare i Suggerimenti AI direttamente
            dalla Gestione Menu utilizzando lo switch dedicato.
          </p>
        </div>
      </section>
    </>
  );
}

function OrdiniIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestisci gli ordini del locale</h2>

        <p>
          La sezione Ordini permette di consultare gli ordini ricevuti,
          controllarne lo stato e distinguere rapidamente quelli effettuati
          in sala da quelli da asporto.
        </p>

        <p>
          Da questa schermata puoi inoltre filtrare gli ordini, modificarli
          oppure eliminarli quando necessario.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="📋"
            titolo="Panoramica ordini"
            testo="Consulta gli ordini e le informazioni principali mostrate nelle relative schede."
            onClick={() => selezionaVoce("ordini-panoramica")}
          />

          <ManualeDashboardItem
            icona="🔎"
            titolo="Filtrare gli ordini"
            testo="Filtra gli ordini per tipologia, stato e periodo."
            onClick={() => selezionaVoce("ordini-filtri")}
          />

          <ManualeDashboardItem
            icona="🔄"
            titolo="Stati degli ordini"
            testo="Consulta gli ordini in base allo stato raggiunto durante il servizio."
            onClick={() => selezionaVoce("ordini-stati")}
          />

          <ManualeDashboardItem
            icona="✏️"
            titolo="Modificare un ordine"
            testo="Apri un ordine esistente per aggiungere piatti o inserire modifiche e note."
            onClick={() => selezionaVoce("ordini-modifica")}
          />

          <ManualeDashboardItem
            icona="🗑️"
            titolo="Eliminare un ordine"
            testo="Utilizza il comando Elimina quando devi rimuovere un ordine."
            onClick={() => selezionaVoce("ordini-elimina")}
          />
        </div>
      </section>
    </>
  );
}

function OrdiniPanoramica() {
  return (
    <>
      <section className="manuale-section">
        <h2>Consultare gli ordini</h2>

        <p>
          Ogni ordine viene visualizzato attraverso una scheda che permette
          di riconoscere rapidamente il tavolo oppure l'ordine da asporto
          e di consultarne le informazioni principali.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua l'ordine"
          testo="Ogni scheda identifica il tavolo oppure l'ordine da asporto."
        />

        <ManualeStep
          numero="2"
          titolo="Controlla lo stato"
          testo="Nella parte superiore della scheda viene mostrato lo stato raggiunto dall'ordine."
        />

        <ManualeStep
          numero="3"
          titolo="Consulta i piatti"
          testo="All'interno della scheda trovi i piatti ordinati, le quantità e lo stato delle singole voci."
        />

        <ManualeStep
          numero="4"
          titolo="Controlla il totale"
          testo="La scheda mostra il totale complessivo dell'ordine."
        />

        <ManualeStep
          numero="5"
          titolo="Usa i comandi disponibili"
          testo="I pulsanti Modifica ed Elimina permettono di intervenire direttamente sull'ordine."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Oggi o Tutti</strong>
          <p>
            Nella parte superiore della schermata puoi utilizzare i pulsanti
            Oggi e Tutti per passare rapidamente dalla visualizzazione degli
            ordini di oggi a quella complessiva.
          </p>
        </div>
      </section>
    </>
  );
}

function OrdiniFiltri() {
  return (
    <>
      <section className="manuale-section">
        <h2>Filtrare gli ordini</h2>

        <p>
          I filtri nella parte superiore della schermata permettono di
          restringere rapidamente gli ordini visualizzati.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Sala / Asporto"
          testo="Scegli Tutti gli ordini, Sala oppure Asporto per visualizzare soltanto la tipologia desiderata."
        />

        <ManualeStep
          numero="2"
          titolo="Stato"
          testo="Utilizza il filtro Stato per mostrare soltanto gli ordini che si trovano in una determinata fase."
        />

        <ManualeStep
          numero="3"
          titolo="Periodo"
          testo="Puoi visualizzare tutto il periodo, questa settimana, questo mese oppure scegliere un intervallo di date."
        />

        <ManualeStep
          numero="4"
          titolo="Azzera filtri"
          testo="Premi Azzera filtri per rimuovere i filtri applicati e tornare alla visualizzazione generale."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔎</span>

        <div>
          <strong>Combina i filtri</strong>
          <p>
            Puoi utilizzare contemporaneamente i filtri Sala / Asporto,
            Stato e Periodo per restringere ulteriormente gli ordini
            visualizzati.
          </p>
        </div>
      </section>
    </>
  );
}

function OrdiniStati() {
  return (
    <>
      <section className="manuale-section">
        <h2>Filtrare per stato</h2>

        <p>
          Il filtro Stato permette di individuare rapidamente gli ordini
          in base alla fase raggiunta durante la loro gestione.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="In attesa"
          testo="Mostra gli ordini che risultano ancora in attesa."
        />

        <ManualeStep
          numero="2"
          titolo="Inviato"
          testo="Mostra gli ordini che risultano inviati."
        />

        <ManualeStep
          numero="3"
          titolo="In preparazione"
          testo="Mostra gli ordini che risultano in preparazione."
        />

        <ManualeStep
          numero="4"
          titolo="Pronto"
          testo="Mostra gli ordini che hanno raggiunto lo stato Pronto."
        />

        <ManualeStep
          numero="5"
          titolo="Servito"
          testo="Mostra gli ordini che risultano serviti."
        />

        <ManualeStep
          numero="6"
          titolo="Pagamento"
          testo="Mostra gli ordini che si trovano nello stato Pagamento."
        />

        <ManualeStep
          numero="7"
          titolo="Pagato"
          testo="Mostra gli ordini che risultano pagati."
        />
      </div>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Tutti gli stati</strong>
          <p>
            Seleziona Tutti gli stati quando vuoi rimuovere il filtro
            relativo allo stato e visualizzare insieme ordini in fasi diverse.
          </p>
        </div>
      </section>
    </>
  );
}

function OrdiniModifica() {
  return (
    <>
      <section className="manuale-section">
        <h2>Come modificare un ordine</h2>

        <p>
          Premi <strong>Modifica</strong> sulla scheda dell'ordine.
          Si aprirà una finestra dalla quale puoi intervenire
          sull'ordine selezionato.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Premi Modifica"
          testo="Individua l'ordine interessato e premi il pulsante Modifica."
        />

        <ManualeStep
          numero="2"
          titolo="Scegli la categoria"
          testo="Utilizza le categorie nella parte superiore della finestra per trovare rapidamente il piatto che vuoi aggiungere."
        />

        <ManualeStep
          numero="3"
          titolo="Aggiungi un piatto"
          testo="Premi il pulsante + accanto al piatto che vuoi aggiungere all'ordine."
        />

        <ManualeStep
          numero="4"
          titolo="Inserisci una modifica o una nota"
          testo="Utilizza il campo Modifica / Nota per specificare eventuali richieste relative al piatto."
        />

        <ManualeStep
          numero="5"
          titolo="Controlla ordine e totale"
          testo="Nella parte inferiore della finestra puoi controllare il numero dei piatti e il totale dell'ordine."
        />

        <ManualeStep
          numero="6"
          titolo="Salva modifiche"
          testo="Premi Salva modifiche per confermare gli aggiornamenti effettuati all'ordine."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✏️</span>

        <div>
          <strong>Modifiche durante il servizio</strong>
          <p>
            La funzione permette di intervenire su un ordine già presente
            senza dover creare un nuovo ordine separato.
          </p>
        </div>
      </section>
    </>
  );
}

function OrdiniElimina() {
  return (
    <>
      <section className="manuale-section">
        <h2>Eliminare un ordine</h2>

        <p>
          Ogni scheda ordine dispone del pulsante
          <strong> Elimina</strong>, utilizzabile quando è necessario
          rimuovere l'ordine.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua l'ordine"
          testo="Trova nella schermata l'ordine che vuoi eliminare."
        />

        <ManualeStep
          numero="2"
          titolo="Premi Elimina"
          testo="Utilizza il pulsante Elimina presente nella scheda dell'ordine."
        />

        <ManualeStep
          numero="3"
          titolo="Verifica l'ordine selezionato"
          testo="Prima di procedere assicurati di avere selezionato l'ordine corretto."
        />
      </div>

      <section className="manuale-note-box">
        <span>⚠️</span>

        <div>
          <strong>Attenzione</strong>
          <p>
            Utilizza Elimina soltanto quando vuoi realmente rimuovere
            l'ordine selezionato.
          </p>
        </div>
      </section>
    </>
  );
}

function CassaIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestisci i pagamenti del locale</h2>

        <p>
          La Dashboard Cassa permette di controllare i tavoli attivi,
          registrare i pagamenti e consultare quelli già pagati.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="💰"
            titolo="Panoramica cassa"
            testo="Consulta i tavoli attivi, gli ordini da asporto e i relativi totali."
            onClick={() => selezionaVoce("cassa-panoramica")}
          />

          <ManualeDashboardItem
            icona="🔎"
            titolo="Filtrare i tavoli"
            testo="Filtra i dati per periodo utilizzando i pulsanti disponibili."
            onClick={() => selezionaVoce("cassa-filtri")}
          />

          <ManualeDashboardItem
            icona="✅"
            titolo="Segnare come pagato"
            testo="Registra il pagamento di un tavolo o di un ordine da asporto."
            onClick={() => selezionaVoce("cassa-pagamento")}
          />

          <ManualeDashboardItem
            icona="👥"
            titolo="Gestione coperti"
            testo="Imposta il numero delle persone presenti al tavolo prima della conferma del pagamento."
            onClick={() => selezionaVoce("cassa-coperti")}
          />

          <ManualeDashboardItem
            icona="🧾"
            titolo="Tavoli pagati"
            testo="Consulta i tavoli e gli ordini già registrati come pagati."
            onClick={() => selezionaVoce("cassa-pagati")}
          />

          <ManualeDashboardItem
            icona="🔒"
            titolo="Chiudi cassa"
            testo="Accedi al comando dedicato alla chiusura della cassa."
            onClick={() => selezionaVoce("cassa-chiusura")}
          />
        </div>
      </section>
    </>
  );
}

function CassaPanoramica() {
  return (
    <>
      <section className="manuale-section">
        <h2>Consultare la Dashboard Cassa</h2>

        <p>
          Nella sezione Tavoli attivi vengono mostrati i tavoli e gli ordini
          da asporto che devono ancora essere registrati come pagati.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il tavolo o l'asporto"
          testo="Ogni scheda identifica il tavolo oppure l'ordine da asporto."
        />

        <ManualeStep
          numero="2"
          titolo="Controlla il totale"
          testo="La scheda mostra il totale relativo all'ordine."
        />

        <ManualeStep
          numero="3"
          titolo="Consulta i piatti"
          testo="All'interno della scheda trovi l'elenco dei piatti compresi nell'ordine."
        />

        <ManualeStep
          numero="4"
          titolo="Controlla lo stato"
          testo="La parte superiore della scheda mostra lo stato dell'ordine."
        />
      </div>
    </>
  );
}

function CassaFiltri() {
  return (
    <>
      <section className="manuale-section">
        <h2>Filtrare i dati della cassa</h2>

        <p>
          I pulsanti temporali permettono di consultare rapidamente
          i tavoli e gli ordini relativi a un determinato periodo.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Tutti"
          testo="Visualizza tutti i dati disponibili."
        />

        <ManualeStep
          numero="2"
          titolo="Oggi"
          testo="Visualizza i dati relativi alla giornata corrente."
        />

        <ManualeStep
          numero="3"
          titolo="Questa settimana"
          testo="Visualizza i dati relativi alla settimana."
        />

        <ManualeStep
          numero="4"
          titolo="Questo mese"
          testo="Visualizza i dati relativi al mese."
        />

        <ManualeStep
          numero="5"
          titolo="Scegli da - a"
          testo="Permette di selezionare un intervallo di date personalizzato."
        />
      </div>
    </>
  );
}

function CassaPagamento() {
  return (
    <>
      <section className="manuale-section">
        <h2>Segnare un ordine come pagato</h2>

        <p>
          Dalla scheda del tavolo o dell'ordine da asporto premi
          <strong> Segna come pagato</strong>.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua l'ordine"
          testo="Trova il tavolo o l'ordine da asporto da registrare come pagato."
        />

        <ManualeStep
          numero="2"
          titolo="Premi Segna come pagato"
          testo="Utilizza il pulsante presente nella parte inferiore della scheda."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla il totale"
          testo="Prima della conferma verifica l'importo mostrato nella finestra di pagamento."
        />

        <ManualeStep
          numero="4"
          titolo="Conferma pagamento"
          testo="Premi Conferma pagamento per registrare il pagamento."
        />
      </div>
    </>
  );
}

function CassaCoperti() {
  return (
    <>
      <section className="manuale-section">
        <h2>Impostare il numero dei coperti</h2>

        <p>
          Per i tavoli, prima della conferma del pagamento viene mostrata
          la finestra dedicata al numero dei coperti.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Controlla il totale ordini"
          testo="La finestra mostra l'importo relativo agli ordini del tavolo."
        />

        <ManualeStep
          numero="2"
          titolo="Imposta il numero di persone"
          testo="Utilizza i pulsanti + e - oppure i numeri disponibili per selezionare i coperti."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla il totale finale"
          testo="La schermata aggiorna il totale finale includendo il valore dei coperti."
        />

        <ManualeStep
          numero="4"
          titolo="Consulta la media per persona"
          testo="La finestra mostra anche la media calcolata per persona."
        />

        <ManualeStep
          numero="5"
          titolo="Conferma il pagamento"
          testo="Premi Conferma pagamento per completare l'operazione."
        />
      </div>
    </>
  );
}

function CassaPagati() {
  return (
    <>
      <section className="manuale-section">
        <h2>Consultare i tavoli pagati</h2>

        <p>
          Premi <strong>Tavoli pagati</strong> per visualizzare gli ordini
          che sono già stati registrati come pagati.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri Tavoli pagati"
          testo="Seleziona la voce Tavoli pagati nella parte superiore della Dashboard Cassa."
        />

        <ManualeStep
          numero="2"
          titolo="Consulta le schede"
          testo="Ogni scheda mostra il tavolo o l'ordine da asporto, il totale e i piatti relativi all'ordine."
        />

        <ManualeStep
          numero="3"
          titolo="Utilizza i filtri temporali"
          testo="Puoi utilizzare Tutti, Oggi, Questa settimana, Questo mese oppure Scegli da - a anche nella visualizzazione dei pagati."
        />
      </div>
    </>
  );
}

function CassaChiusura() {
  return (
    <>
      <section className="manuale-section">
        <h2>Chiudere la cassa</h2>

        <p>
          Nella parte superiore della Dashboard Cassa è disponibile
          il pulsante <strong>Chiudi cassa</strong>.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua Chiudi cassa"
          testo="Il comando si trova nella parte superiore destra della Dashboard Cassa."
        />

        <ManualeStep
          numero="2"
          titolo="Avvia la chiusura"
          testo="Premi Chiudi cassa quando vuoi accedere alla relativa operazione."
        />
      </div>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Chiusura cassa</strong>
          <p>
            In questa guida descriviamo soltanto il comando verificato
            nella Dashboard. Le eventuali schermate successive verranno
            documentate quando saranno verificate.
          </p>
        </div>
      </section>
    </>
  );
}

function AsportoIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestisci il servizio da asporto</h2>

        <p>
          La sezione Gestione Asporto raccoglie le funzioni dedicate
          all'accesso dei clienti al menu da asporto, alla numerazione
          degli ordini e alla configurazione degli slot orari.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="📱"
            titolo="QR Asporto"
            testo="Visualizza il QR Code del menu da asporto, copia il link oppure stampa il QR."
            onClick={() => selezionaVoce("asporto-qr")}
          />

          <ManualeDashboardItem
            icona="🔄"
            titolo="Reset numero asporto"
            testo="Azzera il contatore progressivo degli ordini da asporto."
            onClick={() => selezionaVoce("asporto-reset")}
          />

          <ManualeDashboardItem
            icona="🕒"
            titolo="Slot Asporto"
            testo="Configura gli orari disponibili, la durata degli slot e il numero massimo di pezzi."
            onClick={() => selezionaVoce("asporto-slot")}
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Configurazione centralizzata</strong>
          <p>
            Le principali impostazioni del servizio da asporto sono
            disponibili direttamente dalla Dashboard Gestore.
          </p>
        </div>
      </section>
    </>
  );
}

function AsportoQr() {
  return (
    <>
      <section className="manuale-section">
        <h2>Utilizzare il QR Asporto</h2>

        <p>
          Seleziona <strong>QR Asporto</strong> dalla Gestione Asporto.
          Si aprirà la schermata contenente il QR Code e il collegamento
          al menu da asporto del locale.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri QR Asporto"
          testo="Dalla Gestione Asporto premi il pulsante QR Asporto."
        />

        <ManualeStep
          numero="2"
          titolo="Visualizza il QR Code"
          testo="La schermata mostra il QR Code che permette di aprire il menu da asporto."
        />

        <ManualeStep
          numero="3"
          titolo="Copia il link"
          testo="Premi Copia link per copiare l'indirizzo del menu da asporto e utilizzarlo dove necessario."
        />

        <ManualeStep
          numero="4"
          titolo="Stampa il QR"
          testo="Premi Stampa solo QR per stampare il QR Code."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📱</span>

        <div>
          <strong>Accesso al menu da asporto</strong>
          <p>
            Il cliente può scansionare il QR Code per aprire direttamente
            il menu dedicato agli ordini da asporto.
          </p>
        </div>
      </section>
    </>
  );
}

function AsportoReset() {
  return (
    <>
      <section className="manuale-section">
        <h2>Azzerare il numero degli ordini da asporto</h2>

        <p>
          La funzione <strong>Reset numero asporto</strong> permette
          di azzerare il contatore progressivo utilizzato per gli ordini
          da asporto.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri Reset numero asporto"
          testo="Dalla Gestione Asporto premi Reset numero asporto."
        />

        <ManualeStep
          numero="2"
          titolo="Controlla l'avviso"
          testo="QrMenu mostra una richiesta di conferma prima di azzerare il contatore."
        />

        <ManualeStep
          numero="3"
          titolo="Conferma il reset"
          testo="Premi Conferma reset per azzerare il contatore. Il prossimo ordine ripartirà dal numero 1."
        />

        <ManualeStep
          numero="4"
          titolo="Annulla se necessario"
          testo="Premi Annulla se non vuoi effettuare il reset."
        />
      </div>

      <section className="manuale-note-box">
        <span>⚠️</span>

        <div>
          <strong>Ripartenza dal numero 1</strong>
          <p>
            Dopo la conferma del reset, il successivo ordine da asporto
            ripartirà dal numero 1.
          </p>
        </div>
      </section>
    </>
  );
}

function AsportoSlot() {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare gli Slot Asporto</h2>

        <p>
          Gli Slot Asporto permettono di organizzare gli ordini in fasce
          orarie e di stabilire quanti pezzi possono occupare ciascuno slot.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Attiva gli slot orari"
          testo="Utilizza Attiva slot orari per abilitare o disabilitare la gestione degli slot."
        />

        <ManualeStep
          numero="2"
          titolo="Imposta l'orario"
          testo="Utilizza Ora inizio e Ora fine per definire l'intervallo nel quale rendere disponibili gli slot."
        />

        <ManualeStep
          numero="3"
          titolo="Imposta la durata"
          testo="Nel campo Durata slot minuti indica la durata di ciascuna fascia oraria."
        />

        <ManualeStep
          numero="4"
          titolo="Imposta il massimo di pezzi"
          testo="Nel campo Massimo pezzi per slot stabilisci la capacità massima prevista per ciascuno slot."
        />

        <ManualeStep
          numero="5"
          titolo="Seleziona le categorie"
          testo="Nella sezione Categorie che occupano gli slot seleziona le categorie di piatti che devono essere conteggiate nella capacità dello slot."
        />

        <ManualeStep
          numero="6"
          titolo="Salva la configurazione"
          testo="Dopo aver impostato gli slot, salva la configurazione per applicarla al servizio da asporto."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🕒</span>

        <div>
          <strong>Capacità degli slot</strong>
          <p>
            Soltanto le categorie selezionate nella configurazione vengono
            considerate nel conteggio dei pezzi che occupano gli slot.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Categorie selezionabili</strong>
          <p>
            Puoi scegliere quali categorie incidono sulla capacità degli
            slot, evitando ad esempio di conteggiare categorie che non
            impegnano significativamente la preparazione.
          </p>
        </div>
      </section>
    </>
  );
}

function GestioneCamerieriIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestisci il personale di sala</h2>

        <p>
          Da Gestione Camerieri puoi installare l'App Cameriere,
          creare i profili del personale e configurare le funzioni
          dedicate a ogni cameriere.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="📲"
            titolo="Installare App Cameriere"
            testo="Utilizza il QR Code generale per aprire e installare l'App Cameriere."
            onClick={() => selezionaVoce("camerieri-installazione")}
          />

          <ManualeDashboardItem
            icona="➕"
            titolo="Aggiungere un cameriere"
            testo="Crea un nuovo profilo inserendo il nome del cameriere."
            onClick={() => selezionaVoce("camerieri-aggiungi")}
          />

          <ManualeDashboardItem
            icona="📱"
            titolo="QR personale cameriere"
            testo="Ogni cameriere dispone di un QR Code personale per accedere con il proprio profilo."
            onClick={() => selezionaVoce("camerieri-accesso")}
          />

          <ManualeDashboardItem
            icona="🔔"
            titolo="Categorie di notifica"
            testo="Scegli per quali categorie il cameriere deve ricevere notifiche."
            onClick={() => selezionaVoce("camerieri-notifiche")}
          />

          <ManualeDashboardItem
            icona="⏸️"
            titolo="Standby"
            testo="Gestisci lo stato operativo del cameriere."
            onClick={() => selezionaVoce("camerieri-standby")}
          />

          <ManualeDashboardItem
            icona="🗑️"
            titolo="Eliminare un cameriere"
            testo="Rimuovi un profilo cameriere dalla configurazione del locale."
            onClick={() => selezionaVoce("camerieri-elimina")}
          />
        </div>
      </section>
    </>
  );
}

function CamerieriInstallazione() {
  return (
    <>
      <section className="manuale-section">
        <h2>Installare l'App Cameriere</h2>

        <p>
          Nella parte superiore della Gestione Camerieri è disponibile
          il QR Code dedicato all'installazione dell'App Cameriere.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Scansiona il QR Code"
          testo="Dal dispositivo che verrà utilizzato dal cameriere scansiona il QR Code mostrato nella sezione Installa App Cameriere."
        />

        <ManualeStep
          numero="2"
          titolo="Apri l'app"
          testo="Apri il collegamento sul dispositivo del cameriere."
        />

        <ManualeStep
          numero="3"
          titolo="Installa l'App Cameriere"
          testo="Completa l'installazione dell'app sul dispositivo."
        />

        <ManualeStep
          numero="4"
          titolo="Usa il QR personale"
          testo="Dopo l'installazione utilizza il QR personale del cameriere per accedere con il relativo profilo."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📲</span>

        <div>
          <strong>QR di installazione e QR personale</strong>
          <p>
            Il QR presente in alto serve per installare l'App Cameriere.
            Il QR presente nella scheda di ogni cameriere identifica invece
            il relativo profilo.
          </p>
        </div>
      </section>
    </>
  );
}

function CamerieriAggiungi() {
  return (
    <>
      <section className="manuale-section">
        <h2>Aggiungere un nuovo cameriere</h2>

        <p>
          Utilizza la sezione <strong>Nuovo Cameriere</strong> per creare
          un nuovo profilo dedicato al personale di sala.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Inserisci il nome"
          testo="Scrivi il nome del cameriere nel campo Nome cameriere."
        />

        <ManualeStep
          numero="2"
          titolo="Premi Aggiungi"
          testo="Premi il pulsante Aggiungi per creare il nuovo profilo."
        />

        <ManualeStep
          numero="3"
          titolo="Trova il cameriere tra quelli attivi"
          testo="Il nuovo profilo sarà disponibile nella sezione Camerieri Attivi."
        />
      </div>
    </>
  );
}

function CamerieriAccesso() {
  return (
    <>
      <section className="manuale-section">
        <h2>Utilizzare il QR personale</h2>

        <p>
          Ogni cameriere creato dispone di un proprio QR Code personale.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il cameriere"
          testo="Trova il profilo desiderato nella sezione Camerieri Attivi."
        />

        <ManualeStep
          numero="2"
          titolo="Scansiona il QR personale"
          testo="Dal dispositivo con l'App Cameriere scansiona il QR Code mostrato nella scheda del cameriere."
        />

        <ManualeStep
          numero="3"
          titolo="Accedi con il profilo corretto"
          testo="Il QR personale permette di utilizzare l'App Cameriere con il profilo associato a quel cameriere."
        />
      </div>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Un QR per ogni cameriere</strong>
          <p>
            Utilizza sempre il QR personale corrispondente al cameriere
            che deve utilizzare il dispositivo.
          </p>
        </div>
      </section>
    </>
  );
}

function CamerieriNotifiche() {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare le categorie di notifica</h2>

        <p>
          Premi <strong>Imposta Categoria</strong> nella scheda del cameriere
          per scegliere per quali categorie deve ricevere notifiche.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri Imposta Categoria"
          testo="Premi il pulsante Imposta Categoria nella scheda del cameriere."
        />

        <ManualeStep
          numero="2"
          titolo="Seleziona le categorie"
          testo="Attiva la casella delle categorie per le quali vuoi abilitare le notifiche."
        />

        <ManualeStep
          numero="3"
          titolo="Salva"
          testo="Premi Salva per confermare le categorie selezionate."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔔</span>

        <div>
          <strong>Notifiche in tempo reale</strong>
          <p>
            Quando un cliente ordina un piatto appartenente alle categorie
            selezionate, il cameriere riceve la relativa notifica.
          </p>
        </div>
      </section>
    </>
  );
}

function CamerieriStandby() {
  return (
    <>
      <section className="manuale-section">
        <h2>Mettere un cameriere in Standby</h2>

        <p>
          Nella scheda di ogni cameriere è disponibile il pulsante
          <strong> Standby</strong>.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il cameriere"
          testo="Trova il profilo che vuoi gestire nella sezione Camerieri Attivi."
        />

        <ManualeStep
          numero="2"
          titolo="Premi Standby"
          testo="Utilizza il pulsante Standby per modificare lo stato operativo del cameriere."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla lo stato"
          testo="Verifica lo stato mostrato nella scheda del cameriere."
        />
      </div>
    </>
  );
}

function CamerieriElimina() {
  return (
    <>
      <section className="manuale-section">
        <h2>Eliminare un cameriere</h2>

        <p>
          Il pulsante <strong>Elimina</strong> permette di rimuovere
          il profilo del cameriere.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il cameriere"
          testo="Trova il profilo che vuoi rimuovere."
        />

        <ManualeStep
          numero="2"
          titolo="Premi Elimina"
          testo="Premi il pulsante Elimina nella parte inferiore della scheda."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla il profilo"
          testo="Prima di procedere assicurati di aver selezionato il cameriere corretto."
        />
      </div>

      <section className="manuale-note-box">
        <span>⚠️</span>

        <div>
          <strong>Attenzione</strong>
          <p>
            Utilizza Elimina soltanto quando il profilo del cameriere
            non deve più essere utilizzato.
          </p>
        </div>
      </section>
    </>
  );
}


function AssistenteAIIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Configura e verifica l'Assistente AI</h2>

        <p>
          L'area Assistente AI permette di configurare la strategia
          utilizzata dall'Intelligenza Artificiale e di simulare
          l'esperienza che verrà proposta ai clienti.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="🧪"
            titolo="Simula esperienza cliente"
            testo="Simula il comportamento del cliente e verifica i consigli generati dall'AI."
            onClick={() => selezionaVoce("assistente-ai-simulazione")}
          />

          <ManualeDashboardItem
            icona="💡"
            titolo="Simulazione Upselling"
            testo="Seleziona un piatto e verifica le proposte di upselling generate dall'AI."
            onClick={() => selezionaVoce("assistente-ai-upselling")}
          />

          <ManualeDashboardItem
            icona="⚙️"
            titolo="Regole AI"
            testo="Configura strategia, piatti prioritari e regole dei suggerimenti."
            onClick={() => selezionaVoce("assistente-ai-regole")}
          />

          <ManualeDashboardItem
            icona="🚨"
            titolo="AI Sala"
            testo="Configura gli avvisi intelligenti utilizzati dal Supervisore Sala."
            onClick={() => selezionaVoce("assistente-ai-sala")}
          />
        </div>
      </section>
    </>
  );
}

function AssistenteAISimulazione() {
  return (
    <>
      <section className="manuale-section">
        <h2>Simulare l'esperienza del cliente</h2>

        <p>
          La funzione Simula esperienza cliente permette di verificare
          come l'Intelligenza Artificiale reagisce alle preferenze
          indicate durante la simulazione.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri Simula esperienza cliente"
          testo="Dalla Dashboard Gestore seleziona Simula esperienza cliente."
        />

        <ManualeStep
          numero="2"
          titolo="Imposta il profilo del cliente"
          testo="Seleziona una delle opzioni disponibili nella simulazione del cliente."
        />

        <ManualeStep
          numero="3"
          titolo="Inserisci una nota opzionale"
          testo="Puoi aggiungere una richiesta libera, ad esempio una preferenza, un limite di spesa o un'esigenza particolare."
        />

        <ManualeStep
          numero="4"
          titolo="Genera i consigli AI"
          testo="Premi Genera consigli AI per verificare i suggerimenti prodotti dall'Intelligenza Artificiale."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🧪</span>

        <div>
          <strong>Ambiente di prova</strong>
          <p>
            La simulazione permette al gestore di verificare il comportamento
            dell'Assistente AI prima di valutarne l'esperienza lato cliente.
          </p>
        </div>
      </section>
    </>
  );
}

function AssistenteAIUpselling() {
  return (
    <>
      <section className="manuale-section">
        <h2>Simulare l'Upselling AI</h2>

        <p>
          La sezione Simulazione Upselling AI permette di selezionare
          un piatto del menu e verificare quali suggerimenti vengono
          generati dall'Intelligenza Artificiale.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il piatto"
          testo="Seleziona uno dei piatti mostrati nella simulazione."
        />

        <ManualeStep
          numero="2"
          titolo="Controlla il piatto selezionato"
          testo="La schermata indica quale piatto è stato scelto per la simulazione."
        />

        <ManualeStep
          numero="3"
          titolo="Genera upselling"
          testo="Premi Genera upselling per creare la proposta AI relativa al piatto selezionato."
        />

        <ManualeStep
          numero="4"
          titolo="Valuta il risultato"
          testo="Utilizza la simulazione per verificare se le proposte sono coerenti con la strategia configurata."
        />
      </div>
    </>
  );
}

function AssistenteAIRegole({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare le Regole AI</h2>

        <p>
          La pagina Regole AI permette di definire la strategia con cui
          l'Assistente AI guiderà i suggerimenti mostrati ai clienti.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeDashboardItem
          icona="🎯"
          titolo="Strategia AI"
          testo="Configura obiettivo, intensità e tono."
          onClick={() => selezionaVoce("assistente-ai-strategia")}
        />

        <ManualeDashboardItem
          icona="⭐"
          titolo="Piatti prioritari"
          testo="Scegli i piatti che devono avere maggiore priorità."
          onClick={() => selezionaVoce("assistente-ai-prioritari")}
        />

        <ManualeDashboardItem
          icona="🧠"
          titolo="Regole suggerimenti"
          testo="Configura le categorie da suggerire in base alla scelta del cliente."
          onClick={() => selezionaVoce("assistente-ai-suggerimenti")}
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💾</span>

        <div>
          <strong>Salva configurazione AI</strong>
          <p>
            Dopo aver completato le impostazioni utilizza il comando
            Salva configurazione AI per memorizzare le modifiche.
          </p>
        </div>
      </section>
    </>
  );
}

function AssistenteAIStrategia() {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare la Strategia AI</h2>

        <p>
          La Strategia AI permette di definire il comportamento generale
          utilizzato dall'Assistente nelle proprie proposte.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Scegli l'obiettivo"
          testo="Seleziona Equilibrato, Upselling, Cross selling oppure Fidelizzazione."
        />

        <ManualeStep
          numero="2"
          titolo="Scegli l'intensità"
          testo="Seleziona Soft, Moderata oppure Aggressiva."
        />

        <ManualeStep
          numero="3"
          titolo="Scegli il tono"
          testo="Seleziona Breve, Normale oppure Premium."
        />

        <ManualeStep
          numero="4"
          titolo="Salva la configurazione"
          testo="Quando hai terminato utilizza Salva configurazione AI."
        />
      </div>
    </>
  );
}

function AssistenteAIPrioritari() {
  return (
    <>
      <section className="manuale-section">
        <h2>Selezionare i piatti prioritari</h2>

        <p>
          La sezione Piatti prioritari permette di indicare quali piatti
          devono avere maggiore importanza nella strategia dell'Assistente AI.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Filtra per categoria"
          testo="Utilizza i pulsanti delle categorie per restringere l'elenco dei piatti."
        />

        <ManualeStep
          numero="2"
          titolo="Cerca un piatto"
          testo="Utilizza il campo Cerca piatto per trovare rapidamente un elemento del menu."
        />

        <ManualeStep
          numero="3"
          titolo="Seleziona i piatti"
          testo="Premi sui piatti che vuoi impostare come prioritari."
        />

        <ManualeStep
          numero="4"
          titolo="Controlla il numero selezionato"
          testo="La schermata mostra quanti piatti prioritari risultano selezionati."
        />

        <ManualeStep
          numero="5"
          titolo="Salva"
          testo="Premi Salva configurazione AI per applicare le modifiche."
        />
      </div>
    </>
  );
}

function AssistenteAISuggerimenti() {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare le Regole suggerimenti</h2>

        <p>
          Questa sezione permette di stabilire quali categorie proporre
          quando il cliente sceglie una determinata categoria del menu.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua la categoria di partenza"
          testo="La schermata mostra le regole del tipo Se cliente sceglie: seguito dal nome della categoria."
        />

        <ManualeStep
          numero="2"
          titolo="Seleziona la categoria da suggerire"
          testo="Premi una delle categorie disponibili per associarla alla scelta del cliente."
        />

        <ManualeStep
          numero="3"
          titolo="Configura le altre categorie"
          testo="Ripeti l'operazione per le altre categorie presenti nella pagina."
        />

        <ManualeStep
          numero="4"
          titolo="Salva"
          testo="Premi Salva configurazione AI per memorizzare le regole impostate."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🧠</span>

        <div>
          <strong>Relazioni tra categorie</strong>
          <p>
            Le regole permettono di orientare i suggerimenti dell'Assistente AI
            in funzione della categoria scelta dal cliente.
          </p>
        </div>
      </section>
    </>
  );
}

function AssistenteAISala() {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare AI Sala</h2>

        <p>
          AI Sala permette di personalizzare gli avvisi utilizzati
          dal Supervisore Sala durante il servizio.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri AI Sala"
          testo="Dalla sezione Assistente AI seleziona AI Sala."
        />

        <ManualeStep
          numero="2"
          titolo="Configura Tavolo inattivo"
          testo="Attiva o disattiva l'avviso e imposta dopo quanti minuti deve essere generato quando il cliente è al tavolo senza avere ancora ordinato."
        />

        <ManualeStep
          numero="3"
          titolo="Configura Tavolo servito da"
          testo="Attiva o disattiva l'avviso e imposta il tempo trascorso dall'ultimo ordine del cliente."
        />

        <ManualeStep
          numero="4"
          titolo="Chiudi la configurazione"
          testo="Dopo aver impostato i parametri premi Chiudi."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🚨</span>

        <div>
          <strong>Supervisore Sala</strong>
          <p>
            Gli avvisi configurati aiutano il gestore a individuare
            situazioni che possono richiedere attenzione durante il servizio.
          </p>
        </div>
      </section>
    </>
  );
}

function SalaIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Controlla la sala in tempo reale</h2>

        <p>
          La Sala in tempo reale mostra i tavoli del locale in una griglia
          e permette al gestore di controllare rapidamente la situazione
          durante il servizio.
        </p>

        <p>
          Da questa area puoi aprire un tavolo, gestirne gli ordini,
          inserire un nuovo ordine oppure concludere l'esperienza
          e procedere con l'incasso.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="🪑"
            titolo="Stati dei tavoli"
            testo="Consulta la griglia e riconosci rapidamente la situazione dei tavoli."
            onClick={() => selezionaVoce("sala-stati")}
          />

          <ManualeDashboardItem
            icona="📋"
            titolo="Gestire un tavolo occupato"
            testo="Apri un tavolo attivo per controllare gli ordini e il totale."
            onClick={() => selezionaVoce("sala-occupato")}
          />

          <ManualeDashboardItem
            icona="➕"
            titolo="Inserire un nuovo ordine"
            testo="Aggiungi manualmente piatti e note a un nuovo ordine del tavolo."
            onClick={() => selezionaVoce("sala-nuovo-ordine")}
          />

          <ManualeDashboardItem
            icona="💰"
            titolo="Concludere esperienza e incasso"
            testo="Termina l'esperienza del tavolo e passa alla gestione dell'incasso."
            onClick={() => selezionaVoce("sala-concludi")}
          />

          <ManualeDashboardItem
            icona="🚨"
            titolo="Alert Supervisore Sala"
            testo="Consulta gli avvisi generati dalle funzioni AI dedicate alla sala."
            onClick={() => selezionaVoce("sala-alert")}
          />
        </div>
      </section>
    </>
  );
}

function SalaStati() {
  return (
    <>
      <section className="manuale-section">
        <h2>Leggere lo stato dei tavoli</h2>

        <p>
          I tavoli vengono mostrati attraverso una griglia.
          Il colore della scheda permette di capire rapidamente
          se il tavolo è libero oppure se è in corso un'esperienza.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Individua il tavolo"
          testo="Ogni riquadro della griglia mostra il numero del tavolo."
        />

        <ManualeStep
          numero="2"
          titolo="Tavolo libero"
          testo="I tavoli disponibili vengono mostrati in verde."
        />

        <ManualeStep
          numero="3"
          titolo="Tavolo con attività"
          testo="Quando il tavolo presenta attività o ordini in corso, il suo stato viene evidenziato nella griglia."
        />

        <ManualeStep
          numero="4"
          titolo="Apri il tavolo"
          testo="Premi sul numero del tavolo per accedere alle funzioni disponibili per quella specifica esperienza."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🪑</span>

        <div>
          <strong>Panoramica immediata</strong>
          <p>
            La griglia permette al gestore di controllare rapidamente
            la situazione generale della sala senza aprire singolarmente
            tutti gli ordini.
          </p>
        </div>
      </section>
    </>
  );
}

function SalaOccupato() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire un tavolo occupato</h2>

        <p>
          Premendo su un tavolo con un'esperienza attiva si apre la finestra
          <strong> Controllo esperienza</strong>.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Seleziona il tavolo"
          testo="Premi sul tavolo che vuoi controllare nella griglia Sala in tempo reale."
        />

        <ManualeStep
          numero="2"
          titolo="Controlla gli ordini attivi"
          testo="La finestra mostra quanti ordini risultano attivi per il tavolo."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla il totale"
          testo="Nella stessa finestra viene mostrato il totale complessivo relativo al tavolo."
        />

        <ManualeStep
          numero="4"
          titolo="Gestisci ordini del tavolo"
          testo="Premi Gestisci ordini del tavolo per accedere alla gestione degli ordini relativi a quel tavolo."
        />

        <ManualeStep
          numero="5"
          titolo="Oppure concludi l'esperienza"
          testo="Premi Concludi esperienza e incasso quando vuoi terminare l'esperienza del tavolo e procedere alla fase di incasso."
        />
      </div>
    </>
  );
}

function SalaNuovoOrdine() {
  return (
    <>
      <section className="manuale-section">
        <h2>Inserire un nuovo ordine dal Gestore</h2>

        <p>
          Dalla Sala in tempo reale è possibile aprire un tavolo
          e inserire manualmente un nuovo ordine.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri il tavolo"
          testo="Seleziona dalla griglia il tavolo per il quale vuoi inserire l'ordine."
        />

        <ManualeStep
          numero="2"
          titolo="Scegli la categoria"
          testo="Utilizza le categorie nella parte superiore della finestra Nuovo Ordine per trovare rapidamente i piatti."
        />

        <ManualeStep
          numero="3"
          titolo="Aggiungi il piatto"
          testo="Premi il pulsante + accanto al piatto che vuoi inserire nell'ordine."
        />

        <ManualeStep
          numero="4"
          titolo="Inserisci una modifica o una nota"
          testo="Utilizza il campo Modifica / Nota per aggiungere eventuali richieste relative al piatto."
        />

        <ManualeStep
          numero="5"
          titolo="Controlla quantità e totale"
          testo="La parte inferiore della finestra mostra il numero dei piatti inseriti e il totale dell'ordine."
        />

        <ManualeStep
          numero="6"
          titolo="Invia ordine"
          testo="Quando hai completato l'ordine premi Invia ordine."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">➕</span>

        <div>
          <strong>Ordine inserito dal personale</strong>
          <p>
            Questa funzione permette al gestore di inserire un ordine
            direttamente dalla Sala in tempo reale senza utilizzare
            il menu del cliente.
          </p>
        </div>
      </section>
    </>
  );
}

function SalaConcludi() {
  return (
    <>
      <section className="manuale-section">
        <h2>Concludere esperienza e incasso</h2>

        <p>
          Dal Controllo esperienza del tavolo puoi utilizzare il comando
          <strong> Concludi esperienza e incasso</strong>.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri il tavolo"
          testo="Seleziona dalla Sala in tempo reale il tavolo interessato."
        />

        <ManualeStep
          numero="2"
          titolo="Controlla ordini e totale"
          testo="Prima di procedere verifica il numero degli ordini attivi e il totale mostrato."
        />

        <ManualeStep
          numero="3"
          titolo="Premi Concludi esperienza e incasso"
          testo="Utilizza il pulsante verde per terminare l'esperienza del tavolo e proseguire con la gestione dell'incasso."
        />
      </div>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Controlla prima di concludere</strong>
          <p>
            Prima di terminare l'esperienza verifica che la situazione
            del tavolo e gli ordini presenti siano corretti.
          </p>
        </div>
      </section>
    </>
  );
}

function SalaAlert() {
  return (
    <>
      <section className="manuale-section">
        <h2>Alert del Supervisore Sala</h2>

        <p>
          Il Supervisore Sala può evidenziare situazioni che richiedono
          l'attenzione del gestore durante il servizio.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Controlla gli alert"
          testo="Quando viene rilevata una situazione configurata in AI Sala, il relativo tavolo può essere segnalato al gestore."
        />

        <ManualeStep
          numero="2"
          titolo="Apri il tavolo"
          testo="Seleziona il tavolo segnalato per controllare la situazione e accedere alle relative funzioni."
        />

        <ManualeStep
          numero="3"
          titolo="Gestisci la situazione"
          testo="Utilizza le informazioni disponibili per decidere se intervenire sul tavolo."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🚨</span>

        <div>
          <strong>Configurazione degli alert</strong>
          <p>
            I tempi e le condizioni degli avvisi vengono configurati
            nella sezione Assistente AI → AI Sala.
          </p>
        </div>
      </section>
    </>
  );
}

function PromozioniIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Promuovi offerte e prodotti nel menu</h2>

        <p>
          La sezione Promozioni permette di creare popup promozionali
          che vengono mostrati direttamente al cliente durante
          la consultazione del menu.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Funzioni disponibili</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="🎉"
            titolo="Promozioni Popup"
            testo="Crea, modifica, attiva o sospendi i popup promozionali mostrati nel menu del cliente."
            onClick={() => selezionaVoce("promozioni-popup")}
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Promozione direttamente nel menu</strong>
          <p>
            Quando una promozione è attiva, il cliente visualizza il relativo
            popup direttamente durante l'utilizzo del menu digitale.
          </p>
        </div>
      </section>
    </>
  );
}
function PromozioniPopup() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire le Promozioni Popup</h2>

        <p>
          La sezione Promozioni Popup permette di creare offerte e
          comunicazioni visive che vengono mostrate direttamente
          nel menu del cliente.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Crea una nuova promozione"
          testo="Premi + Nuova Promozione per aprire la schermata di creazione."
        />

        <ManualeStep
          numero="2"
          titolo="Inserisci il titolo"
          testo="Compila il campo Titolo Promozione con il testo che vuoi mostrare al cliente."
        />

        <ManualeStep
          numero="3"
          titolo="Associa un piatto"
          testo="Premi Scegli un piatto dal menu se vuoi collegare la promozione a uno dei prodotti presenti nel menu."
        />

        <ManualeStep
          numero="4"
          titolo="Inserisci un link opzionale"
          testo="Puoi aggiungere un collegamento utilizzando il campo Link. Il campo è facoltativo."
        />

        <ManualeStep
          numero="5"
          titolo="Scegli la dimensione del popup"
          testo="Seleziona Piccolo, Medio, Grande oppure Fullscreen in base a come vuoi mostrare la promozione."
        />

        <ManualeStep
          numero="6"
          titolo="Controlla l'anteprima"
          testo="La schermata mostra un'anteprima del popup che verrà visualizzato dal cliente."
        />

        <ManualeStep
          numero="7"
          titolo="Aggiungi l'immagine"
          testo="Puoi caricare manualmente un'immagine promozionale oppure utilizzare Genera con AI."
        />

        <ManualeStep
          numero="8"
          titolo="Salva la promozione"
          testo="Premi Salva Promozione per memorizzare la nuova promozione."
        />
      </div>

      <section className="manuale-section">
        <h2>Gestire le promozioni create</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controlla lo stato"
            testo="Ogni promozione mostra chiaramente se è ATTIVA oppure IN PAUSA."
          />

          <ManualeStep
            numero="2"
            titolo="Modifica"
            testo="Premi Modifica per aggiornare la promozione."
          />

          <ManualeStep
            numero="3"
            titolo="Attiva o sospendi"
            testo="Premi Attiva per rendere visibile una promozione in pausa oppure Stop per sospendere una promozione attiva."
          />

          <ManualeStep
            numero="4"
            titolo="Elimina"
            testo="Utilizza il pulsante con il cestino quando vuoi eliminare la promozione."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">👁️</span>

        <div>
          <strong>Come appare al cliente</strong>

          <p>
            Quando una promozione è attiva, viene mostrata come popup
            sovrapposto al menu. Il cliente può visualizzare titolo,
            immagine e contenuto promozionale e chiudere il popup
            tramite il pulsante X.
          </p>
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✨</span>

        <div>
          <strong>Generazione immagine con AI</strong>

          <p>
            La funzione Genera con AI permette di creare l'immagine
            promozionale utilizzando i crediti AI Immagini disponibili
            per il locale.
          </p>
        </div>
      </section>
    </>
  );
}

function ChiamateServizio() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire le chiamate di servizio</h2>

        <p>
          Quando un cliente richiede assistenza dal menu, la chiamata
          compare in tempo reale sia nella Dashboard Gestore sia
          nell'App Cameriere.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Controlla le chiamate attive"
          testo="Nella Dashboard Gestore compare il riquadro Chiamate Servizio con il numero delle richieste attive."
        />

        <ManualeStep
          numero="2"
          titolo="Individua il tavolo"
          testo="Ogni richiesta indica il tavolo che ha effettuato la chiamata, ad esempio T1."
        />

        <ManualeStep
          numero="3"
          titolo="Gestisci la richiesta"
          testo="Premi sulla notifica del tavolo quando prendi in carico la chiamata."
        />

        <ManualeStep
          numero="4"
          titolo="Chiamata completata"
          testo="Dopo il clic la richiesta viene considerata gestita e scompare automaticamente."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔄</span>

        <div>
          <strong>Sincronizzazione in tempo reale</strong>

          <p>
            Se la chiamata viene gestita dalla Dashboard Gestore,
            scompare automaticamente anche dall'App Cameriere.
            Lo stesso avviene nel senso opposto.
          </p>
        </div>
      </section>
    </>
  );
}

function ReportGestore() {
  return (
    <>
      <section className="manuale-section">
        <h2>Consultare le Analisi performance</h2>

        <p>
          Il Report Gestore raccoglie i principali indicatori relativi
          all'attività del locale e permette di analizzare vendite,
          ordini, coperti e tempi operativi.
        </p>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">☰</span>

        <div>
          <strong>Come accedere</strong>
          <p>
            Dalla Dashboard Gestore apri il menu hamburger e seleziona
            <strong> Analisi performance</strong>.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Selezionare il periodo</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Oggi"
            testo="Mostra i dati relativi alla giornata corrente."
          />

          <ManualeStep
            numero="2"
            titolo="Ultima settimana"
            testo="Mostra i dati relativi all'ultima settimana."
          />

          <ManualeStep
            numero="3"
            titolo="Ultimo mese"
            testo="Mostra i dati relativi all'ultimo mese."
          />

          <ManualeStep
            numero="4"
            titolo="Tutto"
            testo="Mostra tutti i dati disponibili."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>KPI principali</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Incasso Totale"
            testo="Mostra il valore complessivo degli incassi relativi al periodo selezionato."
          />

          <ManualeStep
            numero="2"
            titolo="Ordini Serviti"
            testo="Mostra il numero complessivo degli ordini serviti nel periodo."
          />

          <ManualeStep
            numero="3"
            titolo="Piatti Venduti"
            testo="Indica quanti piatti sono stati venduti complessivamente."
          />

          <ManualeStep
            numero="4"
            titolo="Coperti Totali"
            testo="Mostra il numero complessivo dei coperti registrati."
          />

          <ManualeStep
            numero="5"
            titolo="Media per Persona"
            testo="Mostra la spesa media calcolata per persona."
          />

          <ManualeStep
            numero="6"
            titolo="Media Ordine"
            testo="Mostra il valore medio economico degli ordini."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Piatti più venduti</h2>

        <p>
          La sezione <strong>Piatti più venduti</strong> permette di
          individuare rapidamente i prodotti che hanno ottenuto i migliori
          risultati nel periodo selezionato.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controlla la classifica"
            testo="I piatti vengono mostrati in base alle vendite registrate."
          />

          <ManualeStep
            numero="2"
            titolo="Consulta le quantità"
            testo="Per ogni piatto viene indicato il numero di unità vendute."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla il valore generato"
            testo="Per ogni piatto viene mostrato anche il relativo valore economico."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Tavoli più attivi</h2>

        <p>
          Questa sezione permette di individuare i tavoli e gli ordini
          da asporto che hanno generato maggiore attività nel periodo.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Consulta il tavolo o l'asporto"
            testo="Ogni scheda identifica il tavolo oppure l'ordine da asporto."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla ordini e coperti"
            testo="La scheda mostra il numero degli ordini e, per i tavoli, i coperti registrati."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla il valore"
            testo="Viene mostrato il valore economico generato dal tavolo o dall'ordine da asporto."
          />

          <ManualeStep
            numero="4"
            titolo="Media per persona"
            testo="Quando sono presenti coperti viene mostrato anche il valore medio per persona."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Tempi medi operativi</h2>

        <p>
          I tempi medi operativi aiutano a valutare la durata
          dell'esperienza del cliente e i tempi di gestione degli ordini.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Giacenza media al tavolo"
            testo="Misura il tempo medio dalla prima scansione del QR Code fino al pagamento."
          />

          <ManualeStep
            numero="2"
            titolo="Tempo medio ordini serviti"
            testo="Misura il tempo medio dall'arrivo dell'ordine in cucina fino al servizio oppure, per l'asporto, fino a quando l'ordine viene indicato come pronto."
          />
        </div>
      </section>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Quando compare N/D</strong>
          <p>
            Se nel periodo selezionato non sono disponibili sessioni complete
            per il calcolo della Giacenza media al tavolo, QrMenu mostra
            <strong> N/D</strong> e il messaggio
            <strong> Nessuna sessione completa disponibile</strong>.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Storico ordini</h2>

        <p>
          Nella parte inferiore del report puoi consultare lo storico
          degli ordini registrati nel periodo selezionato.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Identifica l'ordine"
            testo="Ogni scheda mostra il tavolo oppure l'ordine da asporto."
          />

          <ManualeStep
            numero="2"
            titolo="Consulta coperti e piatti"
            testo="La scheda mostra il numero dei coperti e dei piatti associati all'ordine."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla l'importo"
            testo="Viene mostrato il valore economico complessivo dell'ordine."
          />

          <ManualeStep
            numero="4"
            titolo="Consulta data e ora"
            testo="Ogni voce dello storico mostra la data e l'orario registrati per l'ordine."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📥</span>

        <div>
          <strong>Esporta CSV</strong>
          <p>
            Utilizza il pulsante <strong>Esporta CSV</strong> nella parte
            superiore del Report Gestore per esportare i dati disponibili.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>Il periodo modifica tutto il report</strong>
          <p>
            Cambiando tra Oggi, Ultima settimana, Ultimo mese e Tutto,
            i KPI e le analisi vengono mostrati in riferimento
            al periodo selezionato.
          </p>
        </div>
      </section>
    </>
  );
}

function CamerierePanoramica({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Il centro operativo del cameriere</h2>

        <p>
          L'App Cameriere permette al personale di sala di controllare
          rapidamente lo stato dei tavoli, gestire gli ordini e ricevere
          gli avvisi utili durante il servizio.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Schermata principale</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controlla i tavoli"
            testo="La schermata principale mostra i tavoli del locale organizzati nelle rispettive sale."
          />

          <ManualeStep
            numero="2"
            titolo="Individua i tavoli attivi"
            testo="I colori permettono di riconoscere rapidamente i tavoli liberi e quelli con attività o ordini in corso."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla i piatti pronti"
            testo="Quando la cucina segnala dei piatti pronti viene mostrato un riquadro dedicato con il tavolo interessato."
          />

          <ManualeStep
            numero="4"
            titolo="Consulta gli avvisi AI Sala"
            testo="Quando disponibili, gli avvisi dell'Assistente AI Sala vengono mostrati direttamente nella schermata operativa."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🪑</span>
        <div>
          <strong>Sala sempre sotto controllo</strong>
          <p>
            La griglia permette al cameriere di avere una visione immediata
            della situazione dei tavoli durante il servizio.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Funzioni dell'App Cameriere</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="📱"
            titolo="Installazione"
            testo="Installa l'App Cameriere e accedi con il QR personale."
            onClick={() => selezionaVoce("cameriere-installazione")}
          />

          <ManualeDashboardItem
            icona="🪑"
            titolo="Gestione del servizio"
            testo="Apri i tavoli, consulta gli ordini e inserisci nuovi piatti."
            onClick={() => selezionaVoce("cameriere-utilizzo")}
          />

          <ManualeDashboardItem
            icona="🔔"
            titolo="Notifiche"
            testo="Ricevi gli avvisi utili durante il servizio."
            onClick={() => selezionaVoce("cameriere-notifiche")}
          />

          <ManualeDashboardItem
            icona="⏸️"
            titolo="Standby"
            testo="Metti temporaneamente in pausa il cameriere."
            onClick={() => selezionaVoce("cameriere-standby")}
          />
        </div>
      </section>
    </>
  );
}


function CameriereInstallazione() {
  return (
    <>
      <section className="manuale-section">
        <h2>Installare l'App Cameriere</h2>

        <p>
          Ogni cameriere dispone di un accesso personale configurato dal
          gestore. Il QR personale permette di aprire l'app con il profilo
          corretto.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Apri Gestione Camerieri"
            testo="Il gestore crea il profilo del cameriere dalla sezione Gestione Camerieri."
          />

          <ManualeStep
            numero="2"
            titolo="Apri il QR personale"
            testo="Utilizza il QR Code associato al cameriere che deve configurare il proprio dispositivo."
          />

          <ManualeStep
            numero="3"
            titolo="Scansiona il QR"
            testo="Dal dispositivo del cameriere scansiona il QR personale e apri il collegamento."
          />

          <ManualeStep
            numero="4"
            titolo="Installa l'app"
            testo="Aggiungi QrMenu alla schermata Home del dispositivo per utilizzarlo come App Cameriere."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔐</span>
        <div>
          <strong>QR personale</strong>
          <p>
            Utilizza sempre il QR associato al cameriere corretto: l'accesso
            identifica il profilo utilizzato durante il servizio.
          </p>
        </div>
      </section>

      <section className="manuale-warning-box">
        <span className="manuale-warning-icon">⚠️</span>
        <div>
          <strong>Non condividere gli accessi</strong>
          <p>
            Ogni cameriere deve utilizzare il proprio accesso personale
            configurato dal gestore.
          </p>
        </div>
      </section>
    </>
  );
}


function CameriereUtilizzo() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire i tavoli</h2>

        <p>
          Dalla schermata principale il cameriere può controllare la sala
          e aprire il tavolo sul quale deve intervenire.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Seleziona il tavolo"
            testo="Tocca il numero del tavolo che vuoi gestire."
          />

          <ManualeStep
            numero="2"
            titolo="Consulta l'ordine"
            testo="Nel dettaglio del tavolo puoi vedere i piatti presenti nell'ordine e il totale del tavolo."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla lo stato dei piatti"
            testo="Consulta le informazioni disponibili sui piatti già presenti nell'ordine."
          />

          <ManualeStep
            numero="4"
            titolo="Modifica quando necessario"
            testo="Utilizza i comandi disponibili nel dettaglio dell'ordine quando devi intervenire sull'ordine del tavolo."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Inserire un nuovo ordine</h2>

        <p>
          Il cameriere può inserire direttamente nuovi piatti per un tavolo
          utilizzando il menu del locale.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Apri l'inserimento ordine"
            testo="Accedi alla schermata dedicata all'inserimento di un nuovo ordine."
          />

          <ManualeStep
            numero="2"
            titolo="Scegli la categoria"
            testo="Utilizza le categorie nella parte superiore per trovare rapidamente i piatti."
          />

          <ManualeStep
            numero="3"
            titolo="Aggiungi i piatti"
            testo="Premi il pulsante + accanto al piatto che vuoi aggiungere."
          />

          <ManualeStep
            numero="4"
            titolo="Inserisci eventuali note"
            testo="Utilizza il campo Note per indicare richieste o modifiche relative al piatto."
          />

          <ManualeStep
            numero="5"
            titolo="Invia l'ordine"
            testo="Controlla i piatti selezionati e conferma l'invio dell'ordine."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📝</span>
        <div>
          <strong>Note sull'ordine</strong>
          <p>
            Utilizza le note quando devi comunicare alla cucina una richiesta
            specifica relativa al piatto.
          </p>
        </div>
      </section>
    </>
  );
}


function CameriereNotifiche() {
  return (
    <>
      <section className="manuale-section">
        <h2>Notifiche durante il servizio</h2>

        <p>
          L'App Cameriere segnala le attività che richiedono attenzione,
          permettendo al personale di sala di intervenire rapidamente.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Piatti pronti</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Ricevi l'avviso"
            testo="Quando la cucina segnala dei piatti pronti, l'App Cameriere mostra l'avviso relativo al tavolo interessato."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla il riquadro Piatti pronti"
            testo="Nella schermata principale puoi vedere il tavolo e i piatti che risultano pronti."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla il badge"
            testo="Il tavolo interessato può essere evidenziato anche da un badge numerico."
          />

          <ManualeStep
            numero="4"
            titolo="Servi il tavolo"
            testo="Utilizza le informazioni mostrate per individuare rapidamente il tavolo al quale devono essere consegnati i piatti."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Categorie di notifica</h2>

        <p>
          Il gestore può stabilire per quali categorie del menu ciascun
          cameriere deve ricevere le notifiche.
        </p>

        <section className="manuale-info-box">
          <span className="manuale-info-icon">🔔</span>
          <div>
            <strong>Notifiche personalizzate</strong>
            <p>
              Le categorie vengono configurate dal gestore nella sezione
              Gestione Camerieri. In questo modo ogni cameriere può ricevere
              gli avvisi pertinenti al proprio servizio.
            </p>
          </div>
        </section>
      </section>

      <section className="manuale-section">
        <h2>Chiamate di servizio</h2>

        <p>
          Quando un cliente invia una chiamata di servizio, la richiesta
          viene mostrata anche nell'App Cameriere.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Individua la richiesta"
            testo="L'avviso permette di riconoscere il tavolo dal quale proviene la chiamata."
          />

          <ManualeStep
            numero="2"
            titolo="Prendi in carico la chiamata"
            testo="Tocca la notifica della chiamata di servizio quando intervieni sul tavolo."
          />

          <ManualeStep
            numero="3"
            titolo="Sincronizzazione in tempo reale"
            testo="La chiamata gestita viene aggiornata in tempo reale anche sugli altri dispositivi collegati."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔄</span>
        <div>
          <strong>Aggiornamento in tempo reale</strong>
          <p>
            Gli avvisi vengono sincronizzati tra i dispositivi, evitando che
            una richiesta già gestita continui a risultare attiva.
          </p>
        </div>
      </section>
    </>
  );
}


function CameriereStandby() {
  return (
    <>
      <section className="manuale-section">
        <h2>Mettere il cameriere in Standby</h2>

        <p>
          Lo Standby permette di mettere temporaneamente in pausa il
          cameriere senza eliminare il suo profilo.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Apri il menu"
            testo="Dalla schermata principale dell'App Cameriere premi il pulsante hamburger."
          />

          <ManualeStep
            numero="2"
            titolo="Seleziona Standby"
            testo="Premi Standby per mettere temporaneamente in pausa il profilo."
          />

          <ManualeStep
            numero="3"
            titolo="Riprendi il servizio"
            testo="Quando il cameriere torna operativo, riattiva il profilo per riprendere normalmente il servizio."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">👤</span>
        <div>
          <strong>Controllo anche dal Gestore</strong>
          <p>
            Lo stato Standby può essere gestito anche dal Gestore dalla
            sezione Gestione Camerieri.
          </p>
        </div>
      </section>

      <section className="manuale-warning-box">
        <span className="manuale-warning-icon">🔕</span>
        <div>
          <strong>Cameriere in pausa</strong>
          <p>
            Durante lo Standby il cameriere viene temporaneamente escluso
            dalle notifiche operative finché non viene riattivato.
          </p>
        </div>
      </section>
    </>
  );
}
function CucinaIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>App Cucina</h2>

        <p>
          L'App Cucina permette al personale di ricevere e gestire
          gli ordini del locale in tempo reale da un tablet o da un
          altro dispositivo dedicato alla cucina.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Ricevi gli ordini"
          testo="I nuovi ordini inviati dai clienti o inseriti dal personale arrivano direttamente nell'App Cucina."
        />

        <ManualeStep
          numero="2"
          titolo="Gestisci la preparazione"
          testo="La cucina può controllare i piatti ricevuti e aggiornarne lo stato durante la preparazione."
        />

  <ManualeStep
  numero="3"
  titolo="Segnala i piatti pronti"
  testo="Quando uno o più piatti sono pronti, la cucina può aggiornarne lo stato. Per gli ordini della sala QrMenu può notificare i camerieri dei piatti pronti."
/>

        <ManualeStep
          numero="4"
          titolo="Stampa le comande"
          testo="Se il locale utilizza QrPrint, gli ordini possono essere stampati manualmente oppure automaticamente."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📱</span>

        <div>
          <strong>Dispositivo dedicato</strong>

          <p>
            Per un utilizzo più pratico durante il servizio è consigliato
            installare l'App Cucina su un tablet dedicato alla cucina.
          </p>
        </div>
      </section>

    </>
  );
}
function CucinaInstallazione() {
  return (
    <>
      <section className="manuale-section">
        <h2>Installare l'App Cucina</h2>

        <p>
          L'installazione e la configurazione dell'App Cucina vengono
          avviate dalla Dashboard Gestore utilizzando i QR Code dedicati.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri App Cucina dalla Dashboard Gestore"
          testo="Dalla Dashboard Gestore seleziona App Cucina per visualizzare la schermata dedicata all'installazione e alla configurazione."
        />

        <ManualeStep
          numero="2"
          titolo="Scansiona Installa App"
          testo="Con il tablet che verrà utilizzato in cucina, scansiona il primo QR Code Installa App per aprire l'App Cucina."
        />

        <ManualeStep
          numero="3"
          titolo="Installa l'app sul dispositivo"
          testo="Dal browser utilizza la funzione disponibile per installare o aggiungere l'App Cucina alla schermata principale del dispositivo."
        />

        <ManualeStep
          numero="4"
          titolo="Apri l'App Cucina installata"
          testo="Terminata l'installazione, apri l'App Cucina dal dispositivo."
        />

        <ManualeStep
          numero="5"
          titolo="Scansiona Configura locale"
          testo="Dalla Dashboard Gestore utilizza il secondo QR Code Configura locale. Si aprirà la schermata Configura Cucina."
        />

        <ManualeStep
          numero="6"
          titolo="Consenti l'accesso alla fotocamera"
          testo="Quando il browser richiede l'autorizzazione, consenti l'utilizzo della fotocamera per poter inquadrare il QR del locale."
        />

        <ManualeStep
          numero="7"
          titolo="Inquadra il QR del locale"
          testo="Dalla schermata Configura Cucina inquadra il QR del locale per collegare l'App Cucina al ristorante corretto."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">⌨️</span>

        <div>
          <strong>Configurazione manuale</strong>

          <p>
            Se la fotocamera non è disponibile oppure non riesce a leggere
            il QR Code, inserisci il Codice locale nell'apposito campo e
            premi Configura manualmente.
          </p>
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">💡</span>

        <div>
          <strong>Due QR Code con funzioni diverse</strong>

          <p>
            Il QR Installa App serve ad aprire e installare l'App Cucina.
            Il QR Configura locale serve invece ad avviare la procedura
            che collega l'app al locale corretto.
          </p>
        </div>
      </section>
    </>
  );
}
function CucinaGestioneOrdini() {
  return (
    <>
      <section className="manuale-section">
        <h2>Gestire gli ordini in cucina</h2>

        <p>
          L'App Cucina riceve in tempo reale gli ordini della sala
          e gli ordini da asporto e permette di seguirne la preparazione
          fino a quando i piatti sono pronti.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Stati degli ordini</h2>

        <p>
          Gli ordini vengono organizzati automaticamente in base
          allo stato raggiunto durante la preparazione.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Nuovi"
            testo="Gli ordini appena arrivati vengono visualizzati nella sezione Nuovi. Un ordine non ancora visualizzato può essere evidenziato con la dicitura NUOVO."
          />

          <ManualeStep
            numero="2"
            titolo="In attesa"
            testo="Utilizza In attesa quando uno o più piatti devono essere temporaneamente sospesi prima della preparazione."
          />

          <ManualeStep
            numero="3"
            titolo="In preparazione"
            testo="Utilizza In preparazione quando la cucina inizia a lavorare sui piatti."
          />

          <ManualeStep
            numero="4"
            titolo="Pronto"
            testo="Utilizza Pronto quando la preparazione dei piatti è terminata."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Aprire una comanda</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Individua l'ordine"
            testo="La scheda identifica il tavolo oppure, nel caso dell'asporto, il numero progressivo dell'ordine."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla quantità e orario"
            testo="La scheda mostra il numero dei piatti e l'orario dell'ordine. Per gli ordini da asporto può essere mostrato anche l'orario di ritiro."
          />

          <ManualeStep
            numero="3"
            titolo="Tocca la scheda"
            testo="Premi sulla scheda dell'ordine per aprire il dettaglio completo della comanda."
          />

          <ManualeStep
            numero="4"
            titolo="Consulta i piatti"
            testo="Nel dettaglio puoi vedere i singoli piatti, le quantità, le eventuali modifiche o note e lo stato raggiunto da ciascuna voce."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Gestire singoli piatti</h2>

        <p>
          Non è necessario modificare sempre l'intera comanda.
          L'App Cucina permette di aggiornare anche soltanto
          uno o più piatti selezionati.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Seleziona i piatti"
            testo="Tocca uno o più piatti della comanda per selezionarli."
          />

          <ManualeStep
            numero="2"
            titolo="Seleziona tutti"
            testo="Utilizza Tutti quando vuoi selezionare contemporaneamente tutti i piatti presenti nella scheda."
          />

          <ManualeStep
            numero="3"
            titolo="Scegli il nuovo stato"
            testo="Utilizza i pulsanti disponibili per impostare i piatti selezionati come In attesa, In preparazione oppure Pronto."
          />

          <ManualeStep
            numero="4"
            titolo="Aggiorna l'intero ordine"
            testo="Se non selezioni singoli piatti, il cambio di stato viene applicato all'intera comanda."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔔</span>

        <div>
          <strong>Piatti pronti e App Cameriere</strong>

          <p>
            Quando i piatti di un ordine della sala vengono impostati
            come Pronto, QrMenu può inviare ai camerieri la notifica
            dei piatti pronti per il tavolo interessato.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Ordini da asporto</h2>

        <p>
          Gli ordini da asporto vengono riconosciuti separatamente
          da quelli della sala.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Numero dell'ordine"
            testo="La scheda mostra il numero progressivo dell'ordine da asporto."
          />

          <ManualeStep
            numero="2"
            titolo="Orario di ritiro"
            testo="Quando l'ordine utilizza gli Slot Asporto, viene mostrato anche l'orario di ritiro scelto dal cliente."
          />

          <ManualeStep
            numero="3"
            titolo="Telefono cliente"
            testo="Nel dettaglio dell'ordine può essere visualizzato anche il numero di telefono associato all'ordine da asporto."
          />

          <ManualeStep
            numero="4"
            titolo="Aggiorna la preparazione"
            testo="Anche gli ordini da asporto possono essere gestiti attraverso gli stati In attesa, In preparazione e Pronto."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Viste disponibili</h2>

        <p>
          Dal pannello delle impostazioni puoi cambiare il modo
          in cui vengono organizzate le comande.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="⚡ Sintetico"
            testo="Mostra le comande in formato compatto, così puoi controllare rapidamente il flusso degli ordini."
          />

          <ManualeStep
            numero="2"
            titolo="📋 Completo"
            testo="Mostra direttamente nelle schede anche i piatti presenti negli ordini e permette di selezionarli senza aprire il dettaglio."
          />

          <ManualeStep
            numero="3"
            titolo="🏷️ Categoria"
            testo="Organizza i piatti in base alla categoria del menu, utile quando la cucina è suddivisa in diverse postazioni."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>Filtri</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Filtra per stato"
            testo="Puoi visualizzare tutti gli ordini oppure selezionare uno o più stati tra Inviato, In attesa, In preparazione e Pronto."
          />

          <ManualeStep
            numero="2"
            titolo="Filtra per tipo"
            testo="Puoi visualizzare Tutti gli ordini, soltanto quelli della Sala oppure soltanto quelli da Asporto."
          />

          <ManualeStep
            numero="3"
            titolo="Categorie visibili"
            testo="Da Azioni → Categorie puoi scegliere quali categorie del menu devono essere visualizzate nella postazione cucina."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🏷️</span>

        <div>
          <strong>Categorie per postazione</strong>

          <p>
            Puoi nascondere le categorie che non interessano quella
            postazione di cucina. La selezione viene memorizzata
            sul dispositivo.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Avvisi della cucina</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Segnale acustico"
            testo="Dal pannello Sistema puoi attivare o disattivare il segnale acustico utilizzato per i nuovi ordini."
          />

          <ManualeStep
            numero="2"
            titolo="Notifiche"
            testo="Puoi attivare o disattivare anche le notifiche dell'App Cucina sul dispositivo."
          />
        </div>
      </section>
    </>
  );
}
function CucinaStampaOrdini({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Stampare le comande</h2>

        <p>
          L'App Cucina permette di stampare le comande utilizzando
          QrPrint. La stampa può essere avviata manualmente oppure,
          quando la funzione è abilitata per il locale,
          automaticamente all'arrivo dei nuovi ordini.
        </p>
      </section>

      <section className="manuale-section">
        <h2>Stampa manuale</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Individua la comanda"
            testo="Trova nella Dashboard Cucina l'ordine che vuoi stampare."
          />

          <ManualeStep
            numero="2"
            titolo="Premi Stampa"
            testo="Utilizza il pulsante Stampa presente nella scheda dell'ordine oppure nel dettaglio della comanda."
          />

          <ManualeStep
            numero="3"
            titolo="Invio a QrPrint"
            testo="Se QrPrint è configurato e disponibile sul dispositivo, la comanda viene inviata direttamente al sistema di stampa."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🧾</span>

        <div>
          <strong>Informazioni stampate</strong>

          <p>
            La comanda comprende il tavolo oppure il numero dell'asporto,
            lo stato, la data e l'ora, l'eventuale orario di ritiro,
            i piatti, le quantità e le eventuali modifiche o note.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Stampa automatica</h2>

        <p>
          Quando la stampa automatica è disponibile per il locale,
          nella sezione Azioni compare lo switch
          <strong> Stampa automatica</strong>.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Apri le impostazioni"
            testo="Premi il pulsante con l'ingranaggio per aprire il pannello laterale dell'App Cucina."
          />

          <ManualeStep
            numero="2"
            titolo="Individua Stampa automatica"
            testo="Nella sezione Azioni individua lo switch Stampa automatica."
          />

          <ManualeStep
            numero="3"
            titolo="Attiva la funzione"
            testo="Attiva lo switch per fare in modo che i nuovi ordini vengano inviati automaticamente a QrPrint."
          />

          <ManualeStep
            numero="4"
            titolo="Disattiva quando necessario"
            testo="Disattiva lo switch quando vuoi interrompere temporaneamente la stampa automatica."
          />
        </div>
      </section>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Disponibilità della stampa automatica</strong>

          <p>
            Lo switch viene mostrato soltanto quando la funzione
            di stampa automatica è stata abilitata per il locale.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Configurare QrPrint dalla cucina</h2>

        <p>
          Dal pannello laterale dell'App Cucina è disponibile
          il comando <strong>Impostazioni stampa</strong>.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Apri Impostazioni stampa"
            testo="Dal pannello laterale premi Impostazioni stampa."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla il Codice locale"
            testo="La finestra Configura QrPrint mostra il codice del locale da utilizzare nell'app QrPrint."
          />

          <ManualeStep
            numero="3"
            titolo="Copia il codice"
            testo="Premi Copia codice locale per copiarlo negli appunti."
          />

          <ManualeStep
            numero="4"
            titolo="Apri QrPrint"
            testo="Apri QrPrint sul dispositivo utilizzato per la stampa."
          />

          <ManualeStep
            numero="5"
            titolo="Inserisci il codice locale"
            testo="Inserisci in QrPrint il codice del locale mostrato dall'App Cucina."
          />

          <ManualeStep
            numero="6"
            titolo="Configura la stampante"
            testo="Configura in QrPrint l'indirizzo IP e la porta della stampante ESC/POS."
          />

          <ManualeStep
            numero="7"
            titolo="Esegui una stampa di prova"
            testo="Utilizza QrPrint per verificare che il collegamento con la stampante funzioni correttamente."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">📱</span>

        <div>
          <strong>QrPrint su Android</strong>

          <p>
            Su dispositivi Android, nella finestra di configurazione
            può essere disponibile anche il pulsante per scaricare
            direttamente QrPrint APK.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>🍎</span>

        <div>
          <strong>Dispositivi iOS</strong>

          <p>
            I comandi dedicati a QrPrint e alla stampa delle comande
            non vengono mostrati nell'App Cucina sui dispositivi iOS.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Categorie da inviare alla cucina</h2>

        <p>
          Le categorie selezionate nella configurazione della cucina
          vengono utilizzate anche per determinare quali piatti
          devono essere inclusi nella comanda stampata.
        </p>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🖨️</span>

        <div>
          <strong>Guida completa QrPrint</strong>

          <p>
            Per installazione, configurazione e collegamento della
            stampante consulta la sezione dedicata a QrPrint.
          </p>

          <button
            className="manuale-inline-link"
            onClick={() => selezionaVoce("qrprint-introduzione")}
          >
            Apri la guida QrPrint →
          </button>
        </div>
      </section>
    </>
  );
}
function QrPrintIntro({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Cos'è QrPrint</h2>

        <p>
          QrPrint è l'applicazione utilizzata da QrMenu per collegare
          l'App Cucina a una stampante termica compatibile ESC/POS.
        </p>

        <p>
          Una volta configurato, QrPrint riceve le comande dall'App Cucina
          e le invia direttamente alla stampante collegata alla rete locale.
        </p>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🖨️</span>

        <div>
          <strong>QrPrint lavora insieme all'App Cucina</strong>

          <p>
            L'App Cucina gestisce gli ordini, mentre QrPrint si occupa
            della comunicazione con la stampante.
          </p>
        </div>
      </section>

      <section className="manuale-section">
        <h2>Configurazione guidata</h2>

        <div className="manuale-dashboard-list">
          <ManualeDashboardItem
            icona="📥"
            titolo="Installazione"
            testo="Installa QrPrint sul dispositivo utilizzato in cucina."
            onClick={() => selezionaVoce("qrprint-installazione")}
          />

          <ManualeDashboardItem
            icona="⚙️"
            titolo="Configurazione"
            testo="Inserisci il codice locale e i dati necessari alla stampante."
            onClick={() => selezionaVoce("qrprint-configurazione")}
          />

          <ManualeDashboardItem
            icona="🔌"
            titolo="Collegamento stampante"
            testo="Trova la stampante e verifica la comunicazione."
            onClick={() => selezionaVoce("qrprint-stampante")}
          />

          <ManualeDashboardItem
            icona="⚡"
            titolo="Stampa automatica"
            testo="Configura la stampa automatica dei nuovi ordini."
            onClick={() => selezionaVoce("qrprint-automatica")}
          />

          <ManualeDashboardItem
            icona="🛠️"
            titolo="Problemi comuni"
            testo="Controlla le verifiche principali se QrPrint non stampa."
            onClick={() => selezionaVoce("qrprint-problemi")}
          />
        </div>
      </section>
    </>
  );
}


function QrPrintInstallazione() {
  return (
    <>
      <section className="manuale-section">
        <h2>Installare QrPrint</h2>

        <p>
          QrPrint viene installato sul dispositivo Android utilizzato
          insieme all'App Cucina.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Apri App Cucina"
          testo="Dal dispositivo della cucina apri l'App Cucina."
        />

        <ManualeStep
          numero="2"
          titolo="Apri le impostazioni"
          testo="Premi l'icona dell'ingranaggio per aprire il pannello laterale."
        />

        <ManualeStep
          numero="3"
          titolo="Apri Impostazioni stampa"
          testo="Nella sezione Azioni premi Impostazioni stampa."
        />

        <ManualeStep
          numero="4"
          titolo="Scarica QrPrint"
          testo="Su Android utilizza il pulsante Scarica QrPrint APK per scaricare il file di installazione."
        />

        <ManualeStep
          numero="5"
          titolo="Installa l'APK"
          testo="Apri il file scaricato e completa l'installazione di QrPrint sul dispositivo."
        />

        <ManualeStep
          numero="6"
          titolo="Apri QrPrint"
          testo="Terminata l'installazione apri QrPrint per procedere con la configurazione."
        />
      </div>

      <section className="manuale-note-box">
        <span>📱</span>

        <div>
          <strong>Android</strong>

          <p>
            Il download diretto dell'APK viene reso disponibile
            dall'App Cucina sui dispositivi Android.
          </p>
        </div>
      </section>
    </>
  );
}


function QrPrintConfigurazione() {
  return (
    <>
      <section className="manuale-section">
        <h2>Configurare QrPrint</h2>

        <p>
          Per funzionare correttamente QrPrint deve conoscere il locale
          QrMenu e i dati di rete della stampante.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Recupera il Codice locale"
          testo="Nell'App Cucina apri Impostazioni stampa. La finestra Configura QrPrint mostra il Codice locale."
        />

        <ManualeStep
          numero="2"
          titolo="Copia il codice"
          testo="Premi Copia codice locale oppure annota il codice visualizzato."
        />

        <ManualeStep
          numero="3"
          titolo="Inserisci il Codice locale"
          testo="Apri QrPrint e inserisci nel campo Codice locale QrMenu il codice appena recuperato."
        />

        <ManualeStep
          numero="4"
          titolo="Inserisci l'indirizzo IP"
          testo="Nel campo Indirizzo IP inserisci l'indirizzo di rete della stampante."
        />

        <ManualeStep
          numero="5"
          titolo="Inserisci la porta"
          testo="Nel campo Porta di comunicazione inserisci la porta utilizzata dalla stampante ESC/POS."
        />

        <ManualeStep
          numero="6"
          titolo="Salva la configurazione"
          testo="Premi Salva configurazione per memorizzare i dati inseriti."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔐</span>

        <div>
          <strong>Codice locale</strong>

          <p>
            Il Codice locale permette a QrPrint di identificare
            il locale QrMenu dal quale deve ricevere le richieste
            di stampa.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>💡</span>

        <div>
          <strong>IP e porta</strong>

          <p>
            L'indirizzo IP e la porta devono corrispondere a quelli
            configurati sulla stampante utilizzata dal locale.
          </p>
        </div>
      </section>
    </>
  );
}


function QrPrintStampante() {
  return (
    <>
      <section className="manuale-section">
        <h2>Collegare la stampante</h2>

        <p>
          Dopo aver configurato il locale, QrPrint deve essere collegato
          alla stampante ESC/POS presente sulla rete.
        </p>
      </section>

<section className="manuale-warning-box">
  <span className="manuale-warning-icon">📶</span>

  <div>
    <strong>Importante: stessa rete Wi-Fi</strong>

    <p>
      Il dispositivo utilizzato per l'App Cucina e la stampante devono
      essere collegati alla stessa rete Wi-Fi. Se sono connessi a reti
      diverse, QrPrint non potrà comunicare correttamente con la stampante.
    </p>
  </div>
</section>

      <div className="manuale-dashboard-list">
 <ManualeStep
  numero="1"
  titolo="Collega dispositivo e stampante alla stessa rete Wi-Fi"
  testo="Il dispositivo su cui utilizzi l'App Cucina e la stampante devono essere collegati alla stessa rete Wi-Fi. Prima di procedere, verifica che entrambi siano connessi alla stessa rete."
/>

        <ManualeStep
          numero="2"
          titolo="Cerca la stampante"
          testo="Utilizza Cerca stampante in rete per avviare la ricerca della stampante disponibile."
        />

        <ManualeStep
          numero="3"
          titolo="Controlla IP e porta"
          testo="Verifica che l'indirizzo IP e la porta mostrati o configurati corrispondano alla stampante."
        />

        <ManualeStep
          numero="4"
          titolo="Salva"
          testo="Salva la configurazione prima di effettuare il test."
        />

        <ManualeStep
          numero="5"
          titolo="Esegui stampa di test"
          testo="Premi Esegui stampa di test per verificare che QrPrint riesca a comunicare correttamente con la stampante."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">✅</span>

        <div>
          <strong>Prima verifica</strong>

          <p>
            Prima di attivare la stampa automatica è consigliato
            eseguire sempre una stampa di prova.
          </p>
        </div>
      </section>
    </>
  );
}


function QrPrintAutomatica() {
  return (
    <>
      <section className="manuale-section">
        <h2>Stampa automatica</h2>

        <p>
          Quando la funzione è disponibile per il locale,
          QrPrint può stampare automaticamente le nuove comande
          ricevute dall'App Cucina.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="1"
          titolo="Verifica QrPrint"
          testo="Prima di attivare la stampa automatica assicurati che QrPrint sia configurato e che la stampa di test funzioni."
        />

        <ManualeStep
          numero="2"
          titolo="Apri App Cucina"
          testo="Apri il pannello delle impostazioni dell'App Cucina."
        />

        <ManualeStep
          numero="3"
          titolo="Individua Stampa automatica"
          testo="Nella sezione Azioni individua lo switch Stampa automatica."
        />

        <ManualeStep
          numero="4"
          titolo="Attiva lo switch"
          testo="Attiva Stampa automatica per inviare automaticamente a QrPrint i nuovi ordini ricevuti."
        />

        <ManualeStep
          numero="5"
          titolo="Lascia QrPrint disponibile"
          testo="QrPrint deve essere correttamente configurato e disponibile sul dispositivo affinché le stampe vengano eseguite."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">⚡</span>

        <div>
          <strong>Solo nuovi ordini</strong>

          <p>
            L'attivazione della stampa automatica non deve essere utilizzata
            per ristampare le comande già presenti: il sistema gestisce
            i nuovi elementi ricevuti dopo l'attivazione.
          </p>
        </div>
      </section>

      <section className="manuale-note-box">
        <span>ℹ️</span>

        <div>
          <strong>Funzione abilitata per il locale</strong>

          <p>
            Lo switch Stampa automatica compare nell'App Cucina
            soltanto quando questa funzione è stata abilitata
            per il locale.
          </p>
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🏷️</span>

        <div>
          <strong>Categorie cucina</strong>

          <p>
            La stampa tiene conto delle categorie configurate come visibili
            nella postazione cucina, così la comanda può riportare
            soltanto i piatti pertinenti a quella postazione.
          </p>
        </div>
      </section>
    </>
  );
}


function QrPrintProblemi() {
  return (
    <>
      <section className="manuale-section">
        <h2>Problemi comuni</h2>

        <p>
          Se una comanda non viene stampata, esegui questi controlli
          prima di modificare la configurazione.
        </p>
      </section>

      <section className="manuale-section">
        <h2>La stampante non stampa</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controlla QrPrint"
            testo="Verifica che QrPrint sia installato, aperto e configurato sul dispositivo cucina."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla il Codice locale"
            testo="Verifica che il Codice locale inserito in QrPrint corrisponda a quello mostrato nell'App Cucina."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla IP e porta"
            testo="Verifica che l'indirizzo IP e la porta configurati appartengano alla stampante corretta."
          />

          <ManualeStep
            numero="4"
            titolo="Controlla la rete"
            testo="Assicurati che il dispositivo cucina e la stampante siano collegati alla rete locale corretta."
          />

          <ManualeStep
            numero="5"
            titolo="Esegui una stampa di test"
            testo="Utilizza Esegui stampa di test in QrPrint per verificare direttamente il collegamento con la stampante."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>La stampa automatica non funziona</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controlla lo switch"
            testo="Verifica che Stampa automatica sia attiva nell'App Cucina."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla che la funzione sia disponibile"
            testo="Se lo switch non compare, la stampa automatica non risulta abilitata per il locale."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla QrPrint"
            testo="Verifica che QrPrint sia correttamente configurato e che la stampa di test funzioni."
          />

          <ManualeStep
            numero="4"
            titolo="Prova la stampa manuale"
            testo="Premi Stampa su una comanda dell'App Cucina per verificare se il collegamento con QrPrint funziona manualmente."
          />
        </div>
      </section>

      <section className="manuale-warning-box">
        <span className="manuale-warning-icon">⚠️</span>

        <div>
          <strong>Prima di modificare IP o porta</strong>

          <p>
            Non modificare i parametri della stampante casualmente.
            Verifica prima i dati di rete della stampante e utilizza
            la stampa di test per individuare il problema.
          </p>
        </div>
      </section>
    </>
  );
}

function DomandeFrequenti({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Domande frequenti</h2>

        <p>
          Qui trovi le risposte rapide alle domande più comuni
          sull'utilizzo quotidiano di QrMenu.
        </p>
      </section>

      <div className="manuale-dashboard-list">
        <ManualeStep
          numero="?"
          titolo="Come modifico un piatto del menu?"
          testo="Apri Gestione Menu, individua il piatto e utilizza i comandi di modifica per aggiornare le informazioni."
        />

        <ManualeStep
          numero="?"
          titolo="Posso nascondere temporaneamente un piatto?"
          testo="Sì. Dalla Gestione Menu puoi modificare la visibilità del piatto senza eliminarlo."
        />

        <ManualeStep
          numero="?"
          titolo="Come aggiungo un nuovo cameriere?"
          testo="Apri Gestione Camerieri dalla Dashboard Gestore e crea il nuovo profilo."
        />

        <ManualeStep
          numero="?"
          titolo="Come installo l'App Cameriere?"
          testo="Dalla Gestione Camerieri utilizza il QR dedicato all'installazione e successivamente il QR personale del cameriere per accedere con il profilo corretto."
        />

        <ManualeStep
          numero="?"
          titolo="Come installo l'App Cucina?"
          testo="Dalla Dashboard Gestore apri App Cucina. Utilizza prima il QR Installa App e successivamente Configura locale per collegare la postazione al ristorante."
        />

        <ManualeStep
          numero="?"
          titolo="Posso gestire separatamente i singoli piatti in cucina?"
          testo="Sì. Nell'App Cucina puoi selezionare uno o più piatti e modificarne lo stato indipendentemente dal resto della comanda."
        />

        <ManualeStep
          numero="?"
          titolo="Come vengono avvisati i camerieri quando un piatto è pronto?"
          testo="Quando la cucina imposta i piatti della sala come Pronto, QrMenu può inviare l'avviso ai camerieri interessati."
        />

        <ManualeStep
          numero="?"
          titolo="Posso ricevere ordini da asporto?"
          testo="Sì. QrMenu gestisce gli ordini da asporto separatamente dagli ordini della sala e permette anche di configurare gli Slot Asporto."
        />

        <ManualeStep
          numero="?"
          titolo="Posso tradurre il menu?"
          testo="Sì. Dalla Gestione Menu puoi utilizzare le funzioni di traduzione AI disponibili per piatti, categorie e testi supportati."
        />

        <ManualeStep
          numero="?"
          titolo="Posso stampare automaticamente le comande?"
          testo="Sì, se la stampa automatica è abilitata per il locale e QrPrint è correttamente installato e configurato."
        />

        <ManualeStep
          numero="?"
          titolo="Stampante e tablet devono essere sulla stessa rete Wi-Fi?"
          testo="Sì. Il dispositivo utilizzato per l'App Cucina e la stampante devono essere collegati alla stessa rete Wi-Fi per permettere la comunicazione con QrPrint."
        />

        <ManualeStep
          numero="?"
          titolo="Dove posso vedere statistiche e incassi?"
          testo="Dal menu della Dashboard Gestore apri Analisi performance per consultare KPI, vendite, tempi operativi e storico ordini."
        />
      </div>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🔎</span>

        <div>
          <strong>Cerca nel manuale</strong>
          <p>
            Se non trovi subito quello che cerchi, utilizza il campo
            Cerca nel manuale nella parte superiore della pagina.
          </p>
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🛠️</span>

        <div>
          <strong>Qualcosa non funziona?</strong>
          <p>
            Consulta la sezione Risoluzione problemi per eseguire
            i controlli principali.
          </p>

          <button
            className="manuale-inline-link"
            onClick={() => selezionaVoce("problemi")}
          >
            Vai a Risoluzione problemi →
          </button>
        </div>
      </section>
    </>
  );
}
function RisoluzioneProblemi({ selezionaVoce }) {
  return (
    <>
      <section className="manuale-section">
        <h2>Prima di tutto</h2>

        <p>
          Se una funzione di QrMenu non si comporta come previsto,
          esegui prima alcuni controlli di base.
        </p>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Controlla la connessione"
            testo="Verifica che il dispositivo sia collegato a Internet e che la connessione sia stabile."
          />

          <ManualeStep
            numero="2"
            titolo="Riapri l'app"
            testo="Chiudi e riapri l'App Gestore, Cameriere o Cucina e verifica nuovamente il funzionamento."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla il profilo o il locale"
            testo="Verifica di essere collegato al locale corretto e, per il cameriere, di utilizzare il profilo personale corretto."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>App Cameriere</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Non arrivano le notifiche"
            testo="Controlla che il cameriere non sia in Standby e verifica le categorie di notifica configurate dal Gestore."
          />

          <ManualeStep
            numero="2"
            titolo="Il profilo non è quello corretto"
            testo="Utilizza il QR personale associato al cameriere corretto dalla sezione Gestione Camerieri."
          />

          <ManualeStep
            numero="3"
            titolo="Non vedo i piatti pronti"
            testo="Verifica che la cucina abbia effettivamente impostato i piatti interessati come Pronto."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>App Cucina</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="Non vedo gli ordini"
            testo="Controlla i filtri per stato e tipo e verifica le categorie configurate come visibili nella postazione cucina."
          />

          <ManualeStep
            numero="2"
            titolo="Non sento l'avviso dei nuovi ordini"
            testo="Apri il pannello Sistema e verifica che il segnale acustico sia attivo."
          />

          <ManualeStep
            numero="3"
            titolo="Non ricevo notifiche"
            testo="Apri il pannello Sistema e verifica che le notifiche dell'App Cucina siano attive."
          />
        </div>
      </section>

      <section className="manuale-section">
        <h2>QrPrint e stampante</h2>

        <div className="manuale-dashboard-list">
          <ManualeStep
            numero="1"
            titolo="La stampante non stampa"
            testo="Verifica che QrPrint sia configurato correttamente e prova prima una stampa manuale o una stampa di test."
          />

          <ManualeStep
            numero="2"
            titolo="Controlla la rete Wi-Fi"
            testo="Il dispositivo con l'App Cucina e la stampante devono essere collegati alla stessa rete Wi-Fi."
          />

          <ManualeStep
            numero="3"
            titolo="Controlla IP e porta"
            testo="Verifica che l'indirizzo IP e la porta inseriti in QrPrint corrispondano a quelli della stampante."
          />

          <ManualeStep
            numero="4"
            titolo="Controlla il Codice locale"
            testo="Verifica che il Codice locale configurato in QrPrint corrisponda a quello mostrato dall'App Cucina."
          />

          <ManualeStep
            numero="5"
            titolo="La stampa automatica non parte"
            testo="Verifica che la funzione sia abilitata per il locale e che lo switch Stampa automatica sia attivo nell'App Cucina."
          />
        </div>
      </section>

      <section className="manuale-info-box">
        <span className="manuale-info-icon">🖨️</span>

        <div>
          <strong>Problemi specifici di QrPrint?</strong>
          <p>
            Nella guida QrPrint trovi i controlli dedicati alla
            configurazione e alla stampante.
          </p>

          <button
            className="manuale-inline-link"
            onClick={() => selezionaVoce("qrprint-problemi")}
          >
            Apri Problemi comuni QrPrint →
          </button>
        </div>
      </section>

      <section className="manuale-warning-box">
        <span className="manuale-warning-icon">⚠️</span>

        <div>
          <strong>Evita modifiche casuali</strong>
          <p>
            Prima di modificare configurazioni, codici, indirizzi IP
            o impostazioni del locale, individua il problema utilizzando
            i controlli indicati nel manuale.
          </p>
        </div>
      </section>
    </>
  );
}

function ManualeStep({ numero, titolo, testo }) {
  return (
    <div className="manuale-dashboard-item manuale-step">
      <span className="manuale-step-number">{numero}</span>

      <div>
        <strong>{titolo}</strong>
        <p>{testo}</p>
      </div>
    </div>
  );
}

function ManualeDashboardItem({ icona, titolo, testo, onClick }) {
  return (
    <button className="manuale-dashboard-item" onClick={onClick}>
      <span className="manuale-dashboard-item-icon">{icona}</span>

      <div>
        <strong>{titolo}</strong>
        <p>{testo}</p>
      </div>

      <span className="manuale-dashboard-arrow">›</span>
    </button>
  );
}

function ContenutoInPreparazione() {
  return (
    <section className="manuale-placeholder">
      <div>📘</div>
      <h2>Sezione pronta per essere completata</h2>
      <p>
        Inseriremo qui le istruzioni passo passo, gli screenshot e i consigli
        relativi a questa funzione.
      </p>
    </section>
  );
}

export default ManualeQrMenu;